/* eslint-disable */
import React, { useState, Suspense, useMemo, useCallback, useRef, useEffect, useContext } from "react";
import DateFnsUtils from "@date-io/date-fns";
import ExcelJS from "exceljs";
import "./VEBPlanForm.css";
import "date-fns";
import {
	TextField,
	Paper,
	Select,
	MenuItem,
	Input,
	FormControl,
	Button,
	Box,
	FormGroup,
	FormControlLabel,
	// StepLabel,
	LinearProgress,
	StepIconProps,
	Modal,
	Table,
	TableHead,
	TableRow,
	TableBody,
	ListItemText,
	CheckboxProps,
	Checkbox,
	Switch
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import * as XLSX from "xlsx";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
// import Checkbox, { CheckboxProps } from "@material-ui/core/Checkbox";
import { formatMs, withStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import FormHelperText from "@material-ui/core/FormHelperText";
import EventIcon from "@material-ui/icons/Event";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { useNavigate } from "react-router-dom";
import { trackPromise } from "react-promise-tracker";
import { UIContext } from "../../../../../../contexts";
import { EMPLOYEE_CLASS_ALL } from "../../../../../../constants/employeeClass";
import useRouteParam from "../../../../../../hooks/useRouteParam";
import { FIELD_NAMES, VALIDATION_MESSAGES, VALIDATION_STATUS } from "../../../../../../constants/createVebPlan";
import { Validation } from "../../../../../../@types/validation.types";
import {
	AnswerType,
	Condition,
	CoverageType,
	EmployerDeduction,
	EmployerPremiumDeduction,
	FormField,
	MetaField,
	PlanStatus,
	PremiumRateCoverage,
	PremiumType,
	QuestionNode,
	Routing,
	VEB_Plan
} from "../../../../../../@types/plan.types";
import { EmployeeClass } from "../../../../../../@types/paycheck.types";
import { ADMIN_DASHBOARD_HEADER } from "../../../../../../constants/caption/dashboardHeader";
import shortenFileName from "../../../../../../utils/commonFunctions/shortenFileName";
import downloadFile from "../../../../../../utils/commonFunctions/downloadFile";
import { api } from "../../../../../../utils/api";
import { VEBConfig } from "../../../../../../constants/vebConfig";
import { Add, Check, Delete } from "@material-ui/icons";
import { Grid2 } from "@mui/material";
import { GoogleGenerativeAI } from "@google/generative-ai";
import { jsonToExcel } from "./SchemaToExcel";
import FinalStepButton from "./FinalStepButton";
import { getPrompt } from "./dynamicVEBPrompt/getPrompt";
import { LoadingIndicator } from "../../../../../../utils";
import CircularProgress from "@mui/material/CircularProgress";
import { getJsonFromBackend } from "../../../../../../utils/api/plan/gemini";
import { IoCloseCircleOutline } from "react-icons/io5";
import { getActiveVEBPlans } from "../../../../../../utils/api/plan/plan";
import { TableCell } from "@material-ui/core";
import { buildPremiumStructure, parseCSVSheetsToJSON } from "./VEBpremiumCalculation/VEBpremiumCalculation";

const premiumCoverageColumns = [
	"Coverage", //1
	"Active",
	"Premium Type", //1
	"Monthly Premium", //1
	"Monthly Max Premium", //2
	"Monthly Min Premium", //2
	"Weekly  Premium", //1
	"Weekly Max Premium", //2
	"Weekly Min Premium" //2
];
type PlanOrderItem = {
	plancode: string;
	planOrder: number;
	planName: string;
	planID: any;
};

const employerContributionColumns = ["Coverage", "Active", "Premium Type", "Weekly", "Monthly"];

const GreenCheckbox = withStyles({
	root: {
		color: green[400],
		"&$checked": {
			color: green[600]
		}
	},
	checked: {}
	// eslint-disable-next-line
})((props: CheckboxProps) => <Checkbox color="default" {...props} />);

const employeeCoverage = {
	active: false,
	premium_type: "fixed",
	weekly_premium: null,
	monthly_premium: null
};

const date = new Date();
const minDateRange = date.setDate(date.getDate());

const CreateVEBPlanV2 = (): JSX.Element => {
	const [isFileChanged, setIsFileChanged] = useState(false);
	const [activePlans, setActivePlans] = useState<VEB_Plan[]>([]);
	const [activePlansNames, setActivePlansName] = useState<string[]>([]);
	const [activeRiderPlansNames, setActiveRiderPlansName] = useState<string[]>([]);
	// Add this ref near your other refs
	const excelPayloadRef = useRef<any>(null);
	//setting employeestatus
	const [employee_CLASS, setEmployee_CLASS] = useState(EMPLOYEE_CLASS_ALL);
	const queryGroupNumber = useRouteParam("gn");
	const { setDashboardHeader } = useContext(UIContext);
	const [formData, setFormData] = useState<Record<string, any>>(VEBConfig);
	const [showModal, setShowModal] = useState(false);
	const [planId, setPlanId] = useState<string | undefined>("");
	const [shiftAndMoveToLastPlanOrder, setShiftAndMoveToLastPlanOrder] = useState<{
		shift: boolean;
		moveToLast: boolean;
	}>({
		shift: false,
		moveToLast: false
	});
	const [planOrderList, setPlanOrderList] = useState<PlanOrderItem[]>([]);
	let validationCode: any;

	const [plan, setPlan] = useState({
		group_number: 0,
		plan_name: "",
		plan_code: "",
		status: "",
		start_date: "",
		plan_order: "",
		plan_year: "",
		end_date: "",
		employee_class: "",
		carrier_name: "",
		auto_approve: true,
		is_end_date_required: false,
		document: null
	});
	const [pasted, setPasted] = useState(false);
	const [validation, setValidation] = useState<Validation>({
		plan: {},
		status: VALIDATION_STATUS.valid
	});
	const [step, setStep] = useState(1);
	const [Document, setDocument] = useState<File | null>(null);
	const [excelPayload, setExcelPayload] = useState<any>({});
	const [file, setFile] = useState<File | null>(null);
	const [loading, setLoading] = useState(false);
	const [jsonOutput, setJsonOutput] = useState<any>(null);
	const [currentPlan, setCurrentplan] = useState<VEB_Plan>();
	const [formErrors, setFormErrors] = useState<Record<string, string>>({});

	const [targetOrder, setTargetOrder] = useState<number | null>(null);
	const steps = [
		"Plan Details",
		"Coverage Options",
		"Eligibility Criteria",
		"Employee Age Criteria",
		"Benefit Structure",
		"Add Riders",
		"Upload Plan Excel"
	];
	// const [document, setDocument] = useState<File | null>(null);
	const [isDragging, setIsDragging] = useState(false);
	const _validation = useRef<Validation>();
	const navigate = useNavigate();
	const getallplans = useCallback(async () => {
		try {
			if (!queryGroupNumber) return;

			const { currentPlans, futurePlans } = await getActiveVEBPlans(queryGroupNumber as number);

			//console.log("hi all the plans", currentPlans, futurePlans);
			setActivePlans(currentPlans);
		} catch (error) {
			console.error(error);
		}
	}, [queryGroupNumber]);

	const handleValidation = useCallback(async () => {
		if (!formData) return false;
		// console.log("formData", formData);

		const {
			plan_name = "",
			plan_code = "",
			carrier_name = "",
			status = [],
			is_end_date_required = false,
			employee_class = [],
			start_date,
			plan_year = "",
			plan_order,
			end_date
		} = formData;

		_validation.current = { plan: {}, status: VALIDATION_STATUS.invalid };
		let flag = true;
		let alertMessage = false;

		// --- String fields ---
		// console.log("formdata", formData.start_date);

		if (!plan_name || (typeof plan_name === "string" && plan_name.trim().length === 0)) {
			_validation.current.plan[FIELD_NAMES.plan_name] = VALIDATION_MESSAGES.plan_name_required;
			flag = false;
			alertMessage = true;
		}
		if (!plan_code || (typeof plan_code === "string" && plan_code.trim().length === 0)) {
			_validation.current.plan[FIELD_NAMES.plan_code] = VALIDATION_MESSAGES.plan_code_required;
			flag = false;
			alertMessage = true;
		}
		if (!carrier_name || (typeof carrier_name === "string" && carrier_name.trim().length === 0)) {
			_validation.current.plan[FIELD_NAMES.carrier_name] = VALIDATION_MESSAGES.carrier_name_required;
			flag = false;
			alertMessage = true;
		}
		if (!plan_year || (typeof plan_year === "string" && plan_year.trim().length === 0)) {
			_validation.current.plan[FIELD_NAMES.plan_year] = VALIDATION_MESSAGES.plan_year_required;
			flag = false;
			alertMessage = true;
		}
		// --- Plan Order validation ---
		if (!plan_order && plan_order !== 0) {
			_validation.current.plan[FIELD_NAMES.planOrder] = "Plan order is required.";
			flag = false;
			alertMessage = true;
		} else {
			const currentPlanOrder = Number(plan_order);
			//console.log("currentPlanOrder", currentPlanOrder);

			if (Number.isNaN(currentPlanOrder)) {
				_validation.current.plan[FIELD_NAMES.planOrder] = "Plan order must be a number.";
				flag = false;
				alertMessage = true;
			} else {
				const isDuplicatePlanOrder = planOrderList.some(
					(p) => p.planOrder === currentPlanOrder && p.plancode !== plan_code
				);

				if (isDuplicatePlanOrder) {
					_validation.current.plan[FIELD_NAMES.planOrder] =
						"This plan order is already assigned to another plan.";
					flag = false;
					setShowModal(true);
					alertMessage = true;
				}
			}
		}

		// --- Date fields ---
		if (!start_date || start_date.toString().trim() === "" || isNaN(new Date(start_date).getTime())) {
			_validation.current.plan[FIELD_NAMES.start_date] = VALIDATION_MESSAGES.start_date_required;
			flag = false;
			alertMessage = true;
		}

		if (is_end_date_required && !end_date) {
			_validation.current.plan[FIELD_NAMES.end_date] = VALIDATION_MESSAGES.end_date_required;
			flag = false;
			alertMessage = true;
		}

		// Compare start and end dates only if both exist
		if (start_date && end_date) {
			const startTime = new Date(start_date).getTime();
			const endTime = new Date(end_date).getTime();

			if (startTime === endTime) {
				_validation.current.plan[FIELD_NAMES.end_date] = "Start Date and End Date cannot be the same.";
				flag = false;
				alertMessage = true;
			} else if (startTime > endTime) {
				_validation.current.plan[FIELD_NAMES.end_date] = VALIDATION_MESSAGES.end_date_invalid;
				flag = false;
				alertMessage = true;
			}
		}

		// --- Array fields ---
		if ((!status && typeof status === "string") || (Array.isArray(status) && status.length === 0)) {
			_validation.current.plan[FIELD_NAMES.status] = VALIDATION_MESSAGES.status_required;
			flag = false;
			alertMessage = true;
		}

		// For employee_class
		if (
			(!employee_class && typeof employee_class === "string") ||
			(Array.isArray(employee_class) && employee_class.length === 0)
		) {
			_validation.current.plan[FIELD_NAMES.employee_class] = VALIDATION_MESSAGES.employee_class_required;
			flag = false;
			alertMessage = true;
		}

		// --- Set validation state ---
		_validation.current.status = flag ? VALIDATION_STATUS.valid : VALIDATION_STATUS.invalid;
		setValidation({ ..._validation.current });
		if (!flag && alertMessage) {
			alert("Please, fill all required Plan details!");
		}

		return flag;
	}, [formData, planOrderList, setShowModal]);

	const handleChange = (name: string, value: any) => {
		setFormData((prev) => ({ ...prev, [name]: value }));
	};

	const handleBack = () => {
		if (step >= 6) {
			setStep(5);
			return;
		} else {
			setStep((prev) => Math.max(prev - 1, 1));
		}
	};
	const coverageSort = (coverageArray: string[]): string[] => {
		if (!Array.isArray(coverageArray)) return [];

		const order = [
			"Employee Only",
			"Spouse Only",
			"Children Only",
			"Employee & Spouse",
			"Employee & Children",
			"Employee & Family"
		];

		return [...coverageArray].sort((a, b) => {
			const indexA = order.indexOf(a);
			const indexB = order.indexOf(b);

			// if not found in the order list, push it to the end alphabetically
			if (indexA === -1 && indexB === -1) return a.localeCompare(b);
			if (indexA === -1) return 1;
			if (indexB === -1) return -1;

			return indexA - indexB;
		});
	};
	const formatToTitleCase = (value: string): string => {
		if (!value) return "";

		return value
			.trim()
			.replace(/\s+/g, " ")
			.toLowerCase()
			.replace(/\b\w/g, (char) => char.toUpperCase());
	};

	const trimSpaces = (value: string): string => {
		return value.trim();
	};

	const stepFields = (currentStep: number) => VEBConfig.filter((f: any) => f.step === currentStep);

	const validateDependentEligibility = (
		fd: Record<string, any>,
		prefix: string,
		errors: Record<string, string>
	): boolean => {
		const eligible_relationship = fd[`${prefix}.eligible_relationship`];

		let ok = true;

		if (!Array.isArray(eligible_relationship) || eligible_relationship.length === 0) {
			pushError(
				errors,
				`${prefix}.eligible_relationship`,
				"Please select at least one eligible relationship for dependents."
			);
			return false;
		}

		const checkRange = (min: number, max: number, field: string, label: string, allowEqual = false) => {
			if (isNaN(min) || isNaN(max)) {
				pushError(errors, field, `${label} age must be a valid number.`);
				ok = false;
				return;
			}
			if (allowEqual ? max < min : max <= min) {
				pushError(
					errors,
					field,
					`${label} maximum age must be ${
						allowEqual ? "greater than or equal to" : "greater than"
					} minimum age.`
				);
				ok = false;
			}
		};

		checkRange(
			Number(fd[`${prefix}.spouse.min_age`] ?? 18),
			Number(fd[`${prefix}.spouse.max_age`] ?? 100),
			`${prefix}.spouse.min_age`,
			"Spouse"
		);
		checkRange(
			Number(fd[`${prefix}.children.min_age`] ?? 0),
			Number(fd[`${prefix}.children.max_age`] ?? 26),
			`${prefix}.children.min_age`,
			"Child"
		);
		checkRange(
			Number(fd[`${prefix}.disabled.min_age`] ?? 0),
			Number(fd[`${prefix}.disabled.max_age`] ?? 100),
			`${prefix}.disabled.min_age`,
			"Disabled child",
			true
		);
		return ok;
	};

	const pushError = (errors: Record<string, string>, field: string, message: string) => {
		if (!errors[field]) errors[field] = message;
	};
	const validateEmployeeBenefitBlock = (
		fd: Record<string, any>,
		prefix: string,
		label: string,
		errors: Record<string, string>
	): boolean => {
		const specific = fd[`${prefix}.enable_specific_benefit`];
		const hasBands = fd[`${prefix}.use_predefine_benefit`];
		let ok = true;

		if (!hasBands && !specific) {
			pushError(
				errors,
				`${prefix}.enable_specific_benefit`,
				`Select at least one ${label} benefit option to proceed.`
			);
			return false;
		}
		if (hasBands) {
			const bands = fd[`${prefix}.benefit_band_ranges`];
			if (!Array.isArray(bands) || bands.length < 1) {
				pushError(errors, `${prefix}.benefit_band_ranges`, `Please fill in ${label} benefit band ranges.`);
				ok = false;
			} else {
				const numberRegex = /^[0-9]+$/;
				const cleaned = bands.map((b) => String(b).trim());
				const hasInvalid =
					cleaned.some((v) => v === "" || !numberRegex.test(v)) || new Set(cleaned).size !== cleaned.length;
				if (hasInvalid) {
					pushError(
						errors,
						`${prefix}.benefit_band_ranges`,
						`${label} benefit bands must be valid whole numbers with no duplicates.`
					);
					ok = false;
				}
			}
		}
		if (specific) {
			const min = Number(fd[`${prefix}.min_benefit`]);
			const max = Number(fd[`${prefix}.max_benefit`]);
			if (!min && !max) {
				pushError(errors, `${prefix}.min_benefit`, `Please fill in ${label} minimum and maximum benefit.`);
				ok = false;
			} else if (min >= max) {
				pushError(
					errors,
					`${prefix}.min_benefit`,
					`${label} minimum benefit must be less than maximum benefit.`
				);
				ok = false;
			}
		}
		return ok;
	};
	const validateDependentBenefitBlock = (
		fd: Record<string, any>,
		prefix: string,
		label: string,
		errors: Record<string, string>
	): boolean => {
		const hasRange = fd[`${prefix}.use_predefine_benefit`];
		const hasOptions = fd[`${prefix}.enable_specific_benefit`];
		let ok = true;

		if (!hasRange && !hasOptions) {
			pushError(
				errors,
				`${prefix}.use_predefine_benefit`,
				`Select at least one ${label} benefit option to proceed.`
			);
			return false;
		}
		if (hasRange) {
			const min = Number(fd[`${prefix}.min_benefit`]);
			const max = Number(fd[`${prefix}.max_benefit`]);
			if (!min && !max) {
				pushError(errors, `${prefix}.min_benefit`, `Please fill in ${label} minimum and maximum benefit.`);
				ok = false;
			} else if (min >= max) {
				pushError(
					errors,
					`${prefix}.min_benefit`,
					`${label} minimum benefit must be less than maximum benefit.`
				);
				ok = false;
			}
		}
		if (hasOptions) {
			const options = fd[`${prefix}.options`];
			if (!Array.isArray(options) || options.length === 0) {
				pushError(errors, `${prefix}.options`, `Please add at least one predefined ${label} benefit option.`);
				ok = false;
			} else {
				const numberRegex = /^[0-9]+$/;
				const cleaned = options.map((o) => String(o).trim());
				const hasInvalid =
					cleaned.some((v) => v === "" || !numberRegex.test(v)) || new Set(cleaned).size !== cleaned.length;
				if (hasInvalid) {
					pushError(
						errors,
						`${prefix}.options`,
						`${label} benefit options must be valid whole numbers with no duplicates.`
					);
					ok = false;
				}
			}
		}
		return ok;
	};
	const validateAgeBandBlock = (
		fd: Record<string, any>,
		prefix: string,
		label: string,
		empMin: number,
		empMax: number,
		errors: Record<string, string>
	): boolean => {
		const hasBands = fd[`${prefix}.use_age_bands`];
		const specific = fd[`${prefix}.enable_specific_ages`];
		let ok = true;
		console.log("this is the prefix", prefix);
		if (!hasBands && !specific) {
			pushError(
				errors,
				`${prefix}.use_age_bands`,
				`Select at least one ${label} age criteria option to proceed.`
			);
			return false;
		}
		if (hasBands) {
			const bands: any[] = fd[`${prefix}.age_band_ranges`] || [];
			if (!Array.isArray(bands) || bands.length === 0) {
				pushError(
					errors,
					`${prefix}.age_band_ranges`,
					`Please provide at least one ${label} age band (e.g. 18-60).`
				);
				return false;
			}
			type Range = { min: number; max: number; raw: string };
			const parsed: Range[] = [];
			const pattern = /^\d+-\d+$/;
			for (const band of bands) {
				if (typeof band !== "string" || !pattern.test(band)) {
					pushError(
						errors,
						`${prefix}.age_band_ranges`,
						`Invalid ${label} age band "${band}". Use format 18-60 with no spaces.`
					);
					ok = false;
					break;
				}
				const [bMin, bMax] = band.split("-").map(Number);
				if (bMin >= bMax) {
					pushError(
						errors,
						`${prefix}.age_band_ranges`,
						`Invalid ${label} age band "${band}". Min must be less than Max.`
					);
					ok = false;
					break;
				}
				parsed.push({ min: bMin, max: bMax, raw: band });
			}
			if (ok && parsed.length > 0) {
				parsed.sort((a, b) => a.min - b.min);
				for (let i = 1; i < parsed.length; i++) {
					if (parsed[i].min <= parsed[i - 1].max) {
						pushError(
							errors,
							`${prefix}.age_band_ranges`,
							`Overlapping ${label} age bands "${parsed[i - 1].raw}" and "${parsed[i].raw}".`
						);
						ok = false;
						break;
					}
				}
				if (ok) {
					const isDefault = empMin === 16 && empMax === 100;
					const firstMin = parsed[0].min;
					const lastMax = parsed[parsed.length - 1].max;
					if (isDefault) {
						if (firstMin !== 16 || lastMax !== 100) {
							pushError(
								errors,
								`${prefix}.age_band_ranges`,
								`Default employee eligibility is 16–100. ${label} age criteria must exactly match this range.`
							);
							ok = false;
						}
					} else {
						if (firstMin !== empMin || lastMax !== empMax) {
							pushError(
								errors,
								`${prefix}.age_band_ranges`,
								`${label} age criteria must match eligibility (${empMin}–${empMax}).`
							);
							ok = false;
						}
					}
				}
			}
		}
		if (specific) {
			const specificMin = Number(fd[`${prefix}.min_age`]);
			const specificMax = Number(fd[`${prefix}.max_age`]);
			if (isNaN(specificMin) || isNaN(specificMax)) {
				pushError(errors, `${prefix}.min_age`, `Please enter valid ${label} specific age min and max.`);
				ok = false;
			} else if (specificMin >= specificMax) {
				pushError(errors, `${prefix}.min_age`, `${label} specific age minimum must be less than maximum.`);
				ok = false;
			} else {
				const isDefault = empMin === 16 && empMax === 100;
				if (isDefault) {
					if (specificMin !== 16 || specificMax !== 100) {
						pushError(
							errors,
							`${prefix}.min_age`,
							`Default employee eligibility is 16–100. ${label} specific age range must exactly match this.`
						);
						ok = false;
					}
				} else {
					if (specificMin !== empMin || specificMax !== empMax) {
						pushError(
							errors,
							`${prefix}.min_age`,
							`${label} specific age must match employee eligibility (${empMin}–${empMax}).`
						);
						ok = false;
					}
				}
			}
		}
		return ok;
	};

	const validateIssueAmounts = (
		fd: Record<string, any>,
		prefix: string,
		label: string,
		errors: Record<string, string>
	): boolean => {
		const p = prefix ? `${prefix}.` : "";
		let ok = true;

		if (fd[`${p}has_guaranteed_issue`]) {
			const gi = Number(fd[`${p}guaranteed_issue_amount`]);
			if (!gi || gi <= 0) {
				pushError(
					errors,
					`${p}guaranteed_issue_amount`,
					`Please enter a valid ${label} guaranteed issue amount.`
				);
				ok = false;
			}
		}
		if (fd[`${p}has_simplified_issue`]) {
			const si = Number(fd[`${p}simplified_issue_amount`]);
			if (!si || si <= 0) {
				pushError(
					errors,
					`${p}simplified_issue_amount`,
					`Please enter a valid ${label} simplified issue amount.`
				);
				ok = false;
			}
			if (fd[`${p}has_si_questions`]) {
				const q = fd[`${p}si_questions`];
				if (!Array.isArray(q) || q.length === 0) {
					pushError(
						errors,
						`${p}si_questions`,
						`Please enter at least one ${label} simplified issue health question.`
					);
					ok = false;
				}
			}
		}
		return ok;
	};
	const handleFormValidation = (): boolean => {
		const errors: Record<string, string> = {};
		const empMin = Number(formData["employee_eligibility.min_age"]) || 16;
		const empMax = Number(formData["employee_eligibility.max_age"]) || 100;
		const spouseMin = Number(formData["dependent_eligibility.spouse.min_age"]) || 18;
		const spouseMax = Number(formData["dependent_eligibility.spouse.max_age"]) || 100;
		const childMin = Number(formData["dependent_eligibility.children.min_age"]) || 0;
		const childMax = Number(formData["dependent_eligibility.children.max_age"]) || 26;

		if (step === 2) {
			if (!formData.coverage_for?.length) {
				pushError(errors, "coverage_for", "Please select at least one coverage option.");
			}

			const isEmployeeRequired = formData.employee_require;

			const allowedWithoutEmployee = ["Employee Only", "Spouse Only", "Children Only"];

			if (!isEmployeeRequired) {
				const selected = Array.isArray(formData.coverage_for) ? formData.coverage_for : [formData.coverage_for];

				const invalidSelection = selected.some((option) => !allowedWithoutEmployee.includes(option));

				if (invalidSelection) {
					pushError(
						errors,
						"coverage_for",
						"When employee enrollment is not required, only individual options (Employee Only, Spouse Only, Children Only) are allowed."
					);
				}
			}

			if (!formData.pay_frequency?.length) {
				pushError(errors, "pay_frequency", "Please select at least one payment frequency.");
			}

			if (formData.coverage_volume_present && !formData.coverage_volume?.length) {
				pushError(errors, "coverage_volume", "Please fill in coverage volume.");
			}
		}

		if (step === 3 && formData.isdependent_eligibility) {
			validateDependentEligibility(formData, "dependent_eligibility", errors);

			const coverage = Array.isArray(formData.coverage_for) ? formData.coverage_for : [formData.coverage_for];

			const rels: string[] = formData["dependent_eligibility.eligible_relationship"] ?? [];

			// Normalize coverage mapping
			const needsSpouse =
				coverage.includes("Spouse Only") ||
				coverage.includes("Employee & Spouse") ||
				coverage.includes("Spouse & Children");

			const needsChild =
				coverage.includes("Children Only") ||
				coverage.includes("Employee & Children") ||
				coverage.includes("Spouse & Children");
			const childTypes = ["CHILD", "STEP CHILD", "COURT-ORDER-DEPENDENT", "GRANDCHILD"];

			const hasAnyChildRelation = childTypes.some((rel) => rels.includes(rel));

			if (needsChild && !hasAnyChildRelation) {
				pushError(
					errors,
					"dependent_eligibility.eligible_relationship",
					"Child coverage is selected, so at least one child relationship must be included."
				);
			}
			if (needsSpouse && !rels.includes("SPOUSE")) {
				pushError(
					errors,
					"dependent_eligibility.eligible_relationship",
					"Spouse is selected in coverage, so it must be included in dependent eligibility."
				);
			}
		}

		if (step === 4 && formData["is_this_plan_has_age_criteria"]) {
			validateAgeBandBlock(formData, "age_criteria", "Plan", empMin, empMax, errors);
		}

		if (step === 5 && formData["is_benefit"]) {
			validateEmployeeBenefitBlock(formData, "benefit_amount", "Employee", errors);

			if (formData["benefit_amount.is_benefit_based_on_salary"]) {
				if (formData["benefit_amount.is_benefit_amount_based_on_yearly_salary_percentage"]) {
					const pct = Number(formData["benefit_amount.salary_percentage"]);
					if (!pct || pct <= 0 || pct > 100) {
						pushError(
							errors,
							"benefit_amount.salary_percentage",
							"Please enter a valid salary percentage (1–100)."
						);
					}
				}
				if (formData["benefit_amount.is_benefit_amount_based_on_yearly_salary_multiplier"]) {
					const mult = Number(formData["benefit_amount.yearly_salary_multiplier"]);
					if (!mult || mult <= 0) {
						pushError(
							errors,
							"benefit_amount.yearly_salary_multiplier",
							"Please enter a valid salary multiplier."
						);
					}
				}
			}
			if (formData["benefit_amount.is_each_member_has_different_benefit_amount"]) {
				const rels: string[] = formData["dependent_eligibility.eligible_relationship"] ?? [];

				let hasAtLeastOneSelection = false;

				// 👉 SPOUSE
				if (rels.includes("SPOUSE")) {
					const spousePredefine = formData["benefit_amount.spouse.use_predefine_benefit"];
					const spouseSpecific = formData["benefit_amount.spouse.enable_specific_benefit"];
					const spouseAge = formData["benefit_amount.spouse.premium_depend_on_age"];

					if (spousePredefine || spouseSpecific || spouseAge) {
						hasAtLeastOneSelection = true;
					}
				}

				// 👉 CHILD
				if (rels.includes("CHILD")) {
					const childPredefine = formData["benefit_amount.child.use_predefine_benefit"];
					const childSpecific = formData["benefit_amount.child.enable_specific_benefit"];
					const childAge = formData["benefit_amount.child.premium_depend_on_age"];

					if (childPredefine || childSpecific || childAge) {
						hasAtLeastOneSelection = true;
					}
				}

				// ❌ FINAL CHECK
				if (!hasAtLeastOneSelection) {
					pushError(
						errors,
						"benefit_amount",
						"Please select at least one benefit option or age-based criteria for dependents."
					);
				}
			}

			// this is the original
			if (formData["benefit_amount.is_each_member_has_different_benefit_amount"]) {
				const rels: string[] = formData["dependent_eligibility.eligible_relationship"] ?? [];
				if (
					rels.includes("SPOUSE") &&
					(formData["benefit_amount.spouse.use_predefine_benefit"] ||
						formData["benefit_amount.spouse.enable_specific_benefit"])
				) {
					validateDependentBenefitBlock(formData, "benefit_amount.spouse", "Spouse", errors);
				}
				if (
					rels.includes("CHILD") &&
					(formData["benefit_amount.child.use_predefine_benefit"] ||
						formData["benefit_amount.child.enable_specific_benefit"])
				) {
					validateDependentBenefitBlock(formData, "benefit_amount.child", "Child", errors);
				}
				const hasBothAndCoverage = rels.includes("SPOUSE") && rels.includes("CHILD");
				// &&
				// (Array.isArray(formData["coverage_for"])
				// 	? formData["coverage_for"].includes("Spouse & Children")
				// 	: formData["coverage_for"] === "Spouse & Children");
				// if (hasBothAndCoverage) {
				// 	const sc = "benefit_amount.spose_and_child";
				// 	const useEmployee = formData[`${sc}.use_employee_benefit`];
				// 	const useSpouse = formData[`${sc}.use_spouse_benefit`];
				// 	const useChild = formData[`${sc}.use_child_benefit`];
				// 	const useSeparate = formData[`${sc}.use_seperate_benefit`];
				// 	if (!useEmployee && !useSpouse && !useChild && !useSeparate) {
				// 		pushError(
				// 			errors,
				// 			`${sc}.use_employee_benefit`,
				// 			"Please select how to determine the Spouse & Children combined benefit amount."
				// 		);
				// 	} else if (useSeparate) {
				// 		validateEmployeeBenefitBlock(formData, sc, "Spouse & Child", errors);
				// 	}
				// }
				validateIssueAmounts(formData, "", "employee", errors);
				if (step === 5 && formData["benefit_amount.spouse.premium_depend_on_age"]) {
					validateAgeBandBlock(formData, "benefit_amount.spouse", "Plan", spouseMin, spouseMax, errors);
				}
				if (step === 5 && formData["benefit_amount.child.premium_depend_on_age"]) {
					validateAgeBandBlock(formData, "benefit_amount.child", "Plan", childMin, childMax, errors);
				}
			}
		}

		if (step === 6 && formData["is_this_plan_has_riders"]) {
			if (!formData["rider.name"]) {
				pushError(errors, "rider.name", "Please enter the rider name.");
			}
			let coverageFor: any[] = [];
			if (formData["rider.is_rider_only_for_employee"]) {
				coverageFor = ["Employee Only"];
			} else if (formData["rider.is_rider_has_same_base_plan_coverage_for"]) {
				coverageFor = formData.coverage_for || [];
			} else {
				coverageFor = formData["rider.coverage_for"] || [];
			}
			const normalizedCoverageFor = Array.isArray(coverageFor) ? coverageFor : [coverageFor];
			if (
				normalizedCoverageFor.length === 0 ||
				normalizedCoverageFor.some((item) => item == null || String(item).trim() === "")
			) {
				pushError(errors, "rider.coverage_for", "Please fill in rider coverage.");
			}
			const payFrequency = formData["rider.pay_frequency"];
			const normalizedPayFrequency = Array.isArray(payFrequency)
				? payFrequency
				: payFrequency
				? [payFrequency]
				: [];
			if (
				normalizedPayFrequency.length === 0 ||
				normalizedPayFrequency.some((item) => item == null || String(item).trim() === "")
			) {
				pushError(errors, "rider.pay_frequency", "Please fill in rider payment frequency.");
			}
			if (formData["rider.coverage_volume_present"]) {
				const vol = formData["rider.coverage_volume"];
				if (!Array.isArray(vol) || vol.length === 0 || vol.some((i: any) => i == null || i === "")) {
					pushError(errors, "rider.coverage_volume", "Please fill in rider coverage volume.");
				}
			}
			// if (formData["rider.is_benefit"]) {
			// 	validateEmployeeBenefitBlock(formData, "rider.benefit_amount", "Rider", errors);
			// }
			validateIssueAmounts(formData, "rider", "rider", errors);
			if (formData["rider.is_this_plan_has_age_criteria"]) {
				validateAgeBandBlock(formData, "rider.age_criteria", "Rider", empMin, empMax, errors);
			}
			if (formData["rider.is_rider_dependent_eligibility"]) {
				validateDependentEligibility(formData, "rider.dependent_eligibility", errors);
				const riderRels: string[] = formData["rider.dependent_eligibility.eligible_relationship"] ?? [];
				if (riderRels.includes("SPOUSE")) {
					validateIssueAmounts(formData, "rider.dependent_eligibility.spouse", "rider spouse", errors);
					if (formData["rider.dependent_eligibility.spouse.is_this_plan_has_age_criteria"]) {
						validateAgeBandBlock(
							formData,
							"rider.dependent_eligibility.spouse.age_criteria",
							"Rider Spouse",
							empMin,
							empMax,
							errors
						);
					}
				}
				if (riderRels.includes("CHILD")) {
					validateIssueAmounts(formData, "rider.dependent_eligibility.children", "rider children", errors);
					if (formData["rider.dependent_eligibility.children.is_this_plan_has_age_criteria"]) {
						validateAgeBandBlock(
							formData,
							"rider.dependent_eligibility.children.age_criteria",
							"Rider Children",
							empMin,
							empMax,
							errors
						);
					}
				}
			}
			if (formData["has_questions"]) {
				const q = formData["questions"];
				if (!Array.isArray(q) || q.length === 0) {
					pushError(errors, "questions", "Please enter at least one plan question.");
				}
			}
		}

		if (Object.keys(errors).length > 0) {
			// Show the first error as a single alert
			alert(Object.values(errors)[0]);
			return false;
		}

		return true;
	};

	// ── ErrorSummary banner component (inline, no library needed) ─────────────

	const handleNext = () => {
		handleValidation();
		const isFormValid = handleFormValidation();
		if (!isFormValid) return;
		if (_validation?.current && _validation?.current[FIELD_NAMES.status] === VALIDATION_STATUS.invalid) {
			return;
		}

		// Increment step safely (max 6)
		setStep((prev) => Math.min(prev + 1, 7));
	};
	const renderLabel = (label?: string, required?: boolean) => (
		<span>
			{label}
			{required && <span style={{ color: "red", marginLeft: 2 }}>*</span>}
		</span>
	);

	//console.log("hi fromn the planOrderList", planOrderList);
	useEffect(() => {
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.static_plan_creation);
	}, [setDashboardHeader, file]);
	useEffect(() => {
		if (!activePlans?.length) return;

		const planNames: string[] = activePlans
			.map((plan) => plan.plan_name)
			.filter((name): name is string => Boolean(name));

		const riderPlanname: string[] = activePlans
			.map((plan) => plan.rider?.name)
			.filter((name): name is string => Boolean(name));

		setActivePlansName(planNames);
		setActiveRiderPlansName(riderPlanname);

		const formatted: PlanOrderItem[] = activePlans.map((plan) => ({
			plancode: plan.plan_code,
			planOrder: plan.plan_order,
			planName: plan.plan_name ?? "", // safe fallback
			planID: plan._id
		}));

		setPlanOrderList(formatted);
	}, [activePlans]);

	useEffect(() => {
		getallplans();
	}, [getallplans]);

	const handleConvert = useCallback(
		async (selectedFile?: File) => {
			if (!selectedFile) {
				alert("Please select a file first!");
				return;
			}

			if (!currentPlan) {
				alert("Plan data is not loaded yet. Please try again.");
				return;
			}
			if (!excelPayloadRef.current) {
				alert("Plan data is not loaded yet. Please try again.");
				return;
			}
			console.log("this is the plan", currentPlan);
			console.log("currentPlan shape:", JSON.stringify(currentPlan, null, 2));
			const fileCode = extractNumberFromFileName(selectedFile.name);
			// if (currentPlan?.excel_validation_code) {
			// 	if (currentPlan?.excel_validation_code !== Number(fileCode)) {
			// 		alert("You are not uploading the current excel file");
			// 		return;
			// 	}
			// }
			console.log("currentPlan================>>>>>>", currentPlan);

			// Now TypeScript knows currentPlan is defined here
			// const p = buildPremiumStructure(currentPlan);
			// console.log("this is the premium amount", p);

			setLoading(true);
			setJsonOutput(null);

			try {
				const readFile = (file: File) => {
					return new Promise<ArrayBuffer>((resolve, reject) => {
						const reader = new FileReader();
						reader.onload = () => resolve(reader.result as ArrayBuffer);
						reader.onerror = reject;
						reader.readAsArrayBuffer(file);
					});
				};

				const arrayBuffer = await readFile(selectedFile);
				const workbook = XLSX.read(new Uint8Array(arrayBuffer), { type: "array" });

				let csvText = "";
				workbook.SheetNames.forEach((sheetName, index) => {
					const worksheet = workbook.Sheets[sheetName];
					const sheetCsv = XLSX.utils.sheet_to_csv(worksheet);
					csvText += `\n\n SHEET ${index + 1}: ${sheetName}\n${sheetCsv}`;
				});

				console.log("this is the csv", csvText);

				if (!csvText.trim()) throw new Error("No data extracted from Excel sheets.");
				const parsedJSON = parseCSVSheetsToJSON(csvText);
				console.log("Parsed premium JSON:", parsedJSON);
				setIsFileChanged(false);
				setJsonOutput(parsedJSON);
				setFile(selectedFile);
				setLoading(false);
			} catch (err: any) {
				console.error("Conversion failed:", err);
				alert(err.message);
				setLoading(false);
			}
		},
		[currentPlan, file]
	);
	const handleFieldKeyDown = useCallback((e: React.KeyboardEvent<HTMLElement>) => {
		if (e.key !== "Enter") return;
		e.preventDefault();

		const form = (e.target as HTMLElement).closest("form") ?? document;
		const focusable = Array.from(
			form.querySelectorAll<HTMLElement>(
				'input:not([type="hidden"]):not([disabled]), textarea:not([disabled]), select:not([disabled])'
			)
		).filter((el) => !el.closest('[aria-hidden="true"]'));

		const current = focusable.indexOf(e.target as HTMLElement);
		if (current !== -1 && current < focusable.length - 1) {
			focusable[current + 1].focus();
		}
	}, []);
	const renderField = useCallback(
		(field: FormField | MetaField, parentKey?: string) => {
			const fieldKey = parentKey ? `${parentKey}.${field.name}` : field.name ?? null;

			if (field.condition) {
				const conditions = Array.isArray(field.condition) ? field.condition : [field.condition];

				const evaluateCondition = (cond: Condition): boolean => {
					const currentValue = formData[cond.field];
					let match = false;
					if (cond.includes !== undefined) {
						if (Array.isArray(currentValue)) {
							match = currentValue.includes(cond.includes);
						}
					} else if (cond.value !== undefined) {
						const conditionValues = Array.isArray(cond.value) ? cond.value : [cond.value];
						match = conditionValues.includes(currentValue);
					}
					return cond.not ? !match : match;
				};

				const operator = field.conditionOperator === "OR" ? "OR" : "AND";
				const shouldRender =
					operator === "OR" ? conditions.some(evaluateCondition) : conditions.every(evaluateCondition);

				if (!shouldRender) return null;
			}

			const fieldContainerStyles = {
				display: "flex",
				flexWrap: "wrap",
				mb: 1.5,
				p: { xs: 1, sm: 1.5 },
				backgroundColor: "transparent",
				width: "100%"
			};

			const smallInputStyle = {
				width: "100%",
				maxWidth: { sm: 340 },
				"& .MuiInputBase-input": { padding: "11px 13px" },
				borderRadius: "var(--pf-radius)"
			};

			const labelGrid = { xs: 12, sm: 4, md: 3 };
			const inputGrid = { xs: 12, sm: 8, md: 9 };

			// ── META ─────────────────────────────────────────────────────────────────
			if (field.type === "meta" && field.fields) {
				const metaDepth = (parentKey?.match(/\./g) || []).length;
				const depthClass =
					metaDepth === 0 ? "pf-meta" : metaDepth === 1 ? "pf-meta pf-meta--d1" : "pf-meta pf-meta--d2";

				return (
					<Box key={fieldKey} className={depthClass} sx={{ width: "100%", overflow: "hidden" }}>
						{field.label && <div className="pf-meta-title">{field.label}</div>}
						{field.fields.map((subField: any) => renderField(subField, fieldKey))}
					</Box>
				);
			}

			if (field.type === "array") {
				const arrayValues: string[] = formData[fieldKey] || [""];

				const handleArrayChange = (index: number, value: string) => {
					const updated = [...arrayValues];
					updated[index] = value;
					handleChange(
						fieldKey,
						updated.filter((v) => v.trim() !== "")
					);
				};

				const addItem = () => handleChange(fieldKey, [...arrayValues, ""]);

				const removeItem = (index: number) =>
					handleChange(
						fieldKey,
						arrayValues.filter((_, i) => i !== index)
					);

				const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
					if (e.key === "Enter") {
						e.preventDefault();
						addItem();
					}
				};

				return (
					<Grid
						container
						spacing={2}
						key={fieldKey}
						className="pf-mui-field"
						sx={{ ...fieldContainerStyles, border: "none" }}
					>
						<Grid item {...labelGrid}>
							<div className="pf-label-text">{renderLabel(field.label, field.required)}</div>
						</Grid>
						<Grid item {...inputGrid}>
							{arrayValues.map((val, index) => (
								<Grid
									container
									spacing={1}
									alignItems="center"
									key={index}
									sx={{ mb: 1, flexWrap: "nowrap" }}
								>
									<Grid item xs>
										<TextField
											size="small"
											variant="outlined"
											value={val}
											onChange={(e) => handleArrayChange(index, e.target.value)}
											onKeyDown={(e) => {
												handleFieldKeyDown(e); // ← navigate to next field
												if (e.key === "Enter") addItem(); // ← also add new array item
											}}
											fullWidth
											sx={{
												maxWidth: { sm: 280 },
												"& .MuiInputBase-input": { padding: "11px 13px" }
											}}
										/>
									</Grid>
									<Grid item xs="auto">
										<IconButton color="error" onClick={() => removeItem(index)} size="small">
											<Delete fontSize="small" />
										</IconButton>
									</Grid>
								</Grid>
							))}
							<Box sx={{ mt: 1 }}>
								<Button
									variant="contained"
									startIcon={<Add />}
									size="small"
									onClick={addItem}
									sx={{
										backgroundColor: "var(--pf-accent)",
										textTransform: "none",
										boxShadow: "none"
									}}
								>
									Add
								</Button>
							</Box>
						</Grid>
					</Grid>
				);
			}

			if (field.type === "questions") {
				const questions: QuestionNode[] = formData[fieldKey] || [];
				const generateId = () => `q_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`;
				const updateQuestions = (updated: QuestionNode[]) => handleChange(fieldKey, updated);

				const updateNode = (tree: QuestionNode[], id: string, patch: Partial<QuestionNode>): QuestionNode[] =>
					tree.map((q) =>
						q.id === id
							? { ...q, ...patch }
							: {
									...q,
									follow_ups: q.follow_ups?.map((fu) => ({
										...fu,
										questions: updateNode(fu.questions, id, patch)
									}))
							  }
					);

				const removeNode = (tree: QuestionNode[], id: string): QuestionNode[] =>
					tree
						.filter((q) => q.id !== id)
						.map((q) => ({
							...q,
							follow_ups: q.follow_ups?.map((fu) => ({ ...fu, questions: removeNode(fu.questions, id) }))
						}));

				const addFollowUp = (tree: QuestionNode[], parentId: string, answer: string): QuestionNode[] =>
					tree.map((q) => {
						if (q.id === parentId) {
							const existing = q.follow_ups?.find((fu) => fu.answer === answer);
							if (existing) return q;
							return {
								...q,
								follow_ups: [
									...(q.follow_ups || []),
									{
										answer,
										routing: "next" as Routing,
										questions: [
											{
												id: generateId(),
												text: "",
												answer_type: "yes_no" as const,
												options: [],
												follow_ups: []
											}
										]
									}
								]
							};
						}
						return {
							...q,
							follow_ups: q.follow_ups?.map((fu) => ({
								...fu,
								questions: addFollowUp(fu.questions, parentId, answer)
							}))
						};
					});

				const updateFollowUpRouting = (
					tree: QuestionNode[],
					parentId: string,
					answer: string,
					routing: Routing
				): QuestionNode[] =>
					tree.map((q) => {
						if (q.id === parentId) {
							return {
								...q,
								follow_ups: q.follow_ups?.map((fu) => (fu.answer === answer ? { ...fu, routing } : fu))
							};
						}
						return {
							...q,
							follow_ups: q.follow_ups?.map((fu) => ({
								...fu,
								questions: updateFollowUpRouting(fu.questions, parentId, answer, routing)
							}))
						};
					});

				const routingOptions: { value: Routing; label: string }[] = [
					{ value: "next", label: "Continue to next step" },
					{ value: "prev", label: "Go back to previous step" },
					{ value: "end", label: "End form" }
				];

				const routingSelectSx = {
					minWidth: 200,
					"& .MuiInputBase-input": { padding: "4px 8px", fontSize: 12 }
				};

				const renderQuestionNode = (
					nodes: QuestionNode[],
					onUpdate: (updated: QuestionNode[]) => void,
					depth: number = 0
				): React.ReactNode => (
					<Box
						sx={{
							pl: depth > 0 ? 2 : 0,
							borderLeft: depth > 0 ? "2px solid var(--pf-accent-mid)" : "none",
							mt: 1
						}}
					>
						{nodes.map((q, idx) => {
							const answers = q.answer_type === "yes_no" ? ["Yes", "No"] : q.options || [];

							return (
								<Box
									key={q.id}
									sx={{
										mb: 2,
										p: 1.5,
										backgroundColor: depth % 2 === 0 ? "#f9f9f9" : "var(--pf-accent-light)",
										borderRadius: "var(--pf-radius)",
										border: "0.5px solid var(--pf-border)"
									}}
								>
									{/* Question text + type + delete */}
									{/* Question text + controls */}
									<Box sx={{ display: "flex", flexDirection: "column", gap: 1, mb: 1 }}>
										<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
											<Typography
												variant="caption"
												sx={{ color: "var(--pf-text-hint)", minWidth: 24 }}
											>
												{idx + 1}.
											</Typography>

											<TextField
												size="small"
												fullWidth
												multiline
												minRows={1}
												maxRows={4}
												placeholder="Enter question text"
												value={q.text}
												onChange={(e) =>
													onUpdate(updateNode(nodes, q.id, { text: e.target.value }))
												}
												sx={{ flex: 1 }}
											/>

											<TextField
												select
												size="small"
												value={q.answer_type}
												onChange={(e) =>
													onUpdate(
														updateNode(nodes, q.id, {
															answer_type: e.target.value as AnswerType,
															options: [],
															follow_ups: [],
															routing: {},
															eligibility_answer: null
														})
													)
												}
												sx={{ minWidth: 150 }}
											>
												<MenuItem value="yes_no">Yes / No</MenuItem>
												<MenuItem value="multiple_choice">Multiple Choice</MenuItem>
											</TextField>

											<IconButton
												size="small"
												color="error"
												onClick={() => onUpdate(removeNode(nodes, q.id))}
											>
												<Delete fontSize="small" />
											</IconButton>
										</Box>

										{/* Extra controls row */}
										<Box sx={{ display: "flex", alignItems: "center", gap: 2, pl: 4 }}>
											{/* Required toggle */}
											<FormControlLabel
												control={
													<Switch
														size="small"
														checked={q.have_to_answer || false}
														onChange={(e) =>
															onUpdate(
																updateNode(nodes, q.id, {
																	have_to_answer: e.target.checked
																})
															)
														}
													/>
												}
												label="Required"
												sx={{ "& .MuiTypography-root": { fontSize: 12 } }}
											/>

											{/* Eligibility selector */}
											{(() => {
												const answers =
													q.answer_type === "yes_no" ? ["Yes", "No"] : q.options || [];

												if (!answers.length) return null;

												return (
													<TextField
														select
														size="small"
														label="Eligible if"
														value={q.eligibility_answer || ""}
														onChange={(e) =>
															onUpdate(
																updateNode(nodes, q.id, {
																	eligibility_answer: e.target.value
																})
															)
														}
														sx={{ minWidth: 180 }}
													>
														{answers.map((ans) => (
															<MenuItem key={ans} value={ans}>
																{ans}
															</MenuItem>
														))}
													</TextField>
												);
											})()}
										</Box>
									</Box>

									{/* Multiple choice options */}
									{q.answer_type === "multiple_choice" && (
										<Box sx={{ pl: 4, mb: 1 }}>
											<Typography
												variant="caption"
												sx={{ color: "var(--pf-text-muted)", mb: 0.5, display: "block" }}
											>
												Options
											</Typography>
											{(q.options || []).map((opt, oi) => (
												<Box
													key={oi}
													sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}
												>
													<TextField
														size="small"
														placeholder={`Option ${oi + 1}`}
														value={opt}
														onChange={(e) => {
															const updated = [...(q.options || [])];
															updated[oi] = e.target.value;
															onUpdate(updateNode(nodes, q.id, { options: updated }));
														}}
														sx={{ "& .MuiInputBase-input": { padding: "6px 10px" } }}
													/>
													<IconButton
														size="small"
														color="error"
														onClick={() => {
															const updated = (q.options || []).filter(
																(_, i) => i !== oi
															);
															onUpdate(updateNode(nodes, q.id, { options: updated }));
														}}
													>
														<Delete fontSize="small" />
													</IconButton>
												</Box>
											))}
											<Button
												size="small"
												startIcon={<Add />}
												onClick={() =>
													onUpdate(
														updateNode(nodes, q.id, { options: [...(q.options || []), ""] })
													)
												}
												sx={{ color: "var(--pf-accent)", textTransform: "none" }}
											>
												Add Option
											</Button>
										</Box>
									)}

									{/* Follow-up branches + routing */}
									<Box sx={{ pl: 4 }}>
										<Typography
											variant="caption"
											sx={{ color: "var(--pf-text-muted)", mb: 0.5, display: "block" }}
										>
											Follow-up branches
										</Typography>

										{answers.map((ans) => {
											const existingBranch = q.follow_ups?.find((fu) => fu.answer === ans);
											const routingValue = existingBranch
												? existingBranch.routing
												: q.routing?.[ans] ?? "next";

											return (
												<Box key={ans} sx={{ mb: 1.5 }}>
													{existingBranch ? (
														<Box>
															<Typography
																variant="caption"
																sx={{
																	display: "inline-block",
																	mb: 0.5,
																	px: 1,
																	py: 0.25,
																	backgroundColor: "var(--pf-accent-light)",
																	borderRadius: "var(--pf-radius-pill)",
																	color: "var(--pf-accent)",
																	fontWeight: 500
																}}
															>
																If "{ans}" →
															</Typography>
															{renderQuestionNode(
																existingBranch.questions,
																(updatedChildren) =>
																	onUpdate(
																		updateNode(nodes, q.id, {
																			follow_ups: q.follow_ups?.map((fu) =>
																				fu.answer === ans
																					? {
																							...fu,
																							questions: updatedChildren
																					  }
																					: fu
																			)
																		})
																	),
																depth + 1
															)}
														</Box>
													) : (
														<Button
															size="small"
															variant="outlined"
															startIcon={<Add />}
															sx={{
																fontSize: 11,
																py: 0.25,
																textTransform: "none",
																borderColor: "var(--pf-accent-mid)",
																color: "var(--pf-accent)"
															}}
															onClick={() => onUpdate(addFollowUp(nodes, q.id, ans))}
														>
															Add follow-up if "{ans}"
														</Button>
													)}

													{/* Routing selector — shown for every answer regardless of follow-up */}
													<Box
														sx={{
															display: "flex",
															alignItems: "center",
															gap: 1,
															mt: existingBranch ? 1 : 0.5,
															pl: existingBranch ? 0 : 0
														}}
													>
														<Typography
															variant="caption"
															sx={{
																px: 1,
																py: 0.25,
																borderRadius: "var(--pf-radius-pill)",
																backgroundColor:
																	ans === "Yes"
																		? "#EAF3DE"
																		: ans === "No"
																		? "#FCEBEB"
																		: "var(--pf-accent-light)",
																color:
																	ans === "Yes"
																		? "#3B6D11"
																		: ans === "No"
																		? "#A32D2D"
																		: "var(--pf-accent)",
																fontWeight: 500,
																fontSize: 11,
																whiteSpace: "nowrap"
															}}
														>
															{ans}
														</Typography>
														<Typography
															variant="caption"
															sx={{ color: "var(--pf-text-hint)", whiteSpace: "nowrap" }}
														>
															{existingBranch ? "after follow-up →" : "→"}
														</Typography>
														<TextField
															select
															size="small"
															value={routingValue}
															onChange={(e) => {
																const val = e.target.value as Routing;
																if (existingBranch) {
																	onUpdate(
																		updateFollowUpRouting(nodes, q.id, ans, val)
																	);
																} else {
																	onUpdate(
																		updateNode(nodes, q.id, {
																			routing: {
																				...(q.routing || {}),
																				[ans]: val
																			}
																		})
																	);
																}
															}}
															sx={routingSelectSx}
														>
															{routingOptions.map((opt) => (
																<MenuItem key={opt.value} value={opt.value}>
																	{opt.label}
																</MenuItem>
															))}
														</TextField>
													</Box>
												</Box>
											);
										})}
									</Box>
								</Box>
							);
						})}

						<Button
							size="small"
							variant="contained"
							startIcon={<Add />}
							onClick={() => {
								const newQ: QuestionNode = {
									id: generateId(),
									text: "",
									answer_type: "yes_no",
									options: [],
									follow_ups: [],
									routing: { Yes: "next", No: "next" }
								};
								onUpdate([...nodes, newQ]);
							}}
							sx={{
								mt: 1,
								backgroundColor: "var(--pf-accent)",
								textTransform: "none",
								boxShadow: "none"
							}}
						>
							{depth === 0 ? "Add Question" : "Add Question at this level"}
						</Button>
					</Box>
				);

				return (
					<Grid
						container
						spacing={2}
						key={fieldKey}
						className="pf-mui-field"
						sx={{ ...fieldContainerStyles, border: "none" }}
					>
						<Grid item {...labelGrid}>
							<div className="pf-label-text">{renderLabel(field.label, field.required)}</div>
						</Grid>
						<Grid item {...inputGrid}>
							{renderQuestionNode(questions, updateQuestions)}
						</Grid>
					</Grid>
				);
			}

			if (field.type === "dropdown") {
				const selectedValues: string[] = formData[fieldKey] || [];
				const options: string[] =
					field.optionsKey === "activePlans"
						? activePlansNames
						: field.optionsKey === "activeRiderPlans"
						? activeRiderPlansNames
						: [];

				return (
					<Grid
						container
						spacing={2}
						key={fieldKey}
						className="pf-mui-field"
						sx={{ ...fieldContainerStyles }}
					>
						<Grid item {...labelGrid}>
							<div className="pf-label-text">{renderLabel(field.label, field.required)}</div>
						</Grid>
						<Grid item {...inputGrid}>
							<TextField
								select
								size="small"
								value={selectedValues}
								onChange={(e) => handleChange(fieldKey, e.target.value)}
								SelectProps={{
									multiple: true,
									MenuProps: { PaperProps: { style: { maxHeight: 200 } } },
									renderValue: (selected) =>
										(selected as string[]).length
											? (selected as string[]).join(", ")
											: "Select options"
								}}
								sx={smallInputStyle}
							>
								{options.map((option) => (
									<MenuItem key={option} value={option}>
										<Checkbox
											checked={selectedValues.includes(option)}
											size="small"
											sx={{
												"&.Mui-checked": {
													color: "var(--pf-accent)"
												},
												padding: "4px 8px 4px 0"
											}}
										/>
										<ListItemText primary={option} />
									</MenuItem>
								))}
							</TextField>
						</Grid>
					</Grid>
				);
			}

			if (field.type === "dropdown-with-meta") {
				const selectedMeta: { plan: string; required: boolean; same_coverage: boolean }[] =
					formData[fieldKey] || [];

				const options: string[] =
					field.optionsKey === "activePlans"
						? activePlansNames
						: field.optionsKey === "activeRiderPlans"
						? activeRiderPlansNames
						: [];

				const selectedPlans = selectedMeta.map((m) => m.plan);

				const handlePlanToggle = (plan: string) => {
					const already = selectedMeta.find((m) => m.plan === plan);
					if (already) {
						// deselect — remove it
						handleChange(
							fieldKey,
							selectedMeta.filter((m) => m.plan !== plan)
						);
					} else {
						// select — add with defaults
						handleChange(fieldKey, [...selectedMeta, { plan, required: false, same_coverage: false }]);
					}
				};

				const handleMetaChange = (plan: string, key: "required" | "same_coverage", value: boolean) => {
					handleChange(
						fieldKey,
						selectedMeta.map((m) => (m.plan === plan ? { ...m, [key]: value } : m))
					);
				};

				return (
					<Grid
						container
						spacing={2}
						key={fieldKey}
						className="pf-mui-field"
						sx={{ ...fieldContainerStyles }}
					>
						<Grid item {...labelGrid}>
							<div className="pf-label-text">{renderLabel(field.label, field.required)}</div>
						</Grid>

						<Grid item {...inputGrid}>
							{/* ── Dropdown selector ── */}
							<TextField
								select
								size="small"
								value={selectedPlans}
								onChange={() => {}} // controlled via MenuItem clicks
								SelectProps={{
									multiple: true,
									MenuProps: { PaperProps: { style: { maxHeight: 200 } } },
									renderValue: (selected) =>
										(selected as string[]).length
											? (selected as string[]).join(", ")
											: "Select plans"
								}}
								sx={smallInputStyle}
							>
								{options.map((option) => (
									<MenuItem key={option} value={option} onClick={() => handlePlanToggle(option)}>
										<Checkbox
											checked={selectedPlans.includes(option)}
											size="small"
											sx={{
												"&.Mui-checked": { color: "var(--pf-accent)" },
												padding: "4px 8px 4px 0"
											}}
										/>
										<ListItemText primary={option} />
									</MenuItem>
								))}
							</TextField>

							{/* ── Per-plan meta rows ── */}
							{selectedMeta.length > 0 && (
								<Box
									sx={{
										mt: 1.5,
										border: "1px solid var(--pf-border)",
										borderRadius: "var(--pf-radius)",
										overflow: "hidden"
									}}
								>
									{/* Header */}
									<Box
										sx={{
											display: "grid",
											gridTemplateColumns: "1fr 110px 130px",
											alignItems: "center",
											px: 1.5,
											py: 0.75,
											backgroundColor: "var(--pf-accent-light)",
											borderBottom: "1px solid var(--pf-border)"
										}}
									>
										<Typography
											variant="caption"
											sx={{ fontWeight: 600, color: "var(--pf-text-muted)" }}
										>
											Plan
										</Typography>
										<Typography
											variant="caption"
											sx={{ fontWeight: 600, color: "var(--pf-text-muted)", textAlign: "center" }}
										>
											Required
										</Typography>
										<Typography
											variant="caption"
											sx={{ fontWeight: 600, color: "var(--pf-text-muted)", textAlign: "center" }}
										>
											Same Coverage
										</Typography>
									</Box>

									{/* Rows */}
									{selectedMeta.map((meta, idx) => (
										<Box
											key={meta.plan}
											sx={{
												display: "grid",
												gridTemplateColumns: "1fr 110px 130px",
												alignItems: "center",
												px: 1.5,
												py: 0.75,
												backgroundColor: idx % 2 === 0 ? "#fff" : "var(--pf-accent-light)",
												borderBottom:
													idx < selectedMeta.length - 1
														? "1px solid var(--pf-border)"
														: "none"
											}}
										>
											<Typography variant="body2" sx={{ fontSize: 13 }}>
												{meta.plan}
											</Typography>

											<Box sx={{ display: "flex", justifyContent: "center" }}>
												<Switch
													size="small"
													checked={meta.required}
													onChange={(e) =>
														handleMetaChange(meta.plan, "required", e.target.checked)
													}
													sx={{
														"& .MuiSwitch-switchBase.Mui-checked": {
															color: "var(--pf-accent)"
														},
														"& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
															backgroundColor: "var(--pf-accent)"
														}
													}}
												/>
											</Box>

											<Box sx={{ display: "flex", justifyContent: "center" }}>
												<Switch
													size="small"
													checked={meta.same_coverage}
													onChange={(e) =>
														handleMetaChange(meta.plan, "same_coverage", e.target.checked)
													}
													sx={{
														"& .MuiSwitch-switchBase.Mui-checked": {
															color: "var(--pf-accent)"
														},
														"& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
															backgroundColor: "var(--pf-accent)"
														}
													}}
												/>
											</Box>
										</Box>
									))}
								</Box>
							)}
						</Grid>
					</Grid>
				);
			}

			// ── MULTISELECT ───────────────────────────────────────────────────────────
			// if (field.type === "multiselect") {
			// 	let selectedValues: string[] = formData[fieldKey] || [];
			// 	let selectedValues2: string[] = [];
			// 	if (fieldKey === "rider.coverage_for" && formData["rider.is_rider_only_for_employee"]) {
			// 		selectedValues2 = ["Employee Only"];
			// 		selectedValues = selectedValues2;
			// 	} else if (
			// 		fieldKey === "rider.coverage_for" &&
			// 		formData["rider.is_rider_has_same_base_plan_coverage_for"]
			// 	) {
			// 		selectedValues2 = Array.isArray(formData.coverage_for)
			// 			? formData.coverage_for
			// 			: formData.coverage_for?.options || [];
			// 		selectedValues = selectedValues2;
			// 	}

			// 	const toggleOption = (option: string) => {
			// 		let updatedValues: string[];
			// 		if (selectedValues.includes(option)) {
			// 			updatedValues = selectedValues.filter((v) => v !== option);
			// 		} else {
			// 			if (
			// 				fieldKey === "rider.coverage_for" &&
			// 				formData["rider.is_rider_has_same_base_plan_coverage_for"]
			// 			) {
			// 				updatedValues = Array.from(new Set([...selectedValues2, option]));
			// 			} else {
			// 				updatedValues = [...selectedValues, option];
			// 			}
			// 		}
			// 		handleChange(fieldKey, updatedValues);
			// 	};

			// 	return (
			// 		<Grid
			// 			container
			// 			spacing={2}
			// 			key={fieldKey}
			// 			className="pf-mui-field"
			// 			sx={{ ...fieldContainerStyles }}
			// 		>
			// 			<Grid item {...labelGrid}>
			// 				<div className="pf-label-text">{renderLabel(field.label, field.required)}</div>
			// 			</Grid>
			// 			<Grid item {...inputGrid}>
			// 				{/* Chips instead of checkboxes */}
			// 				<div className="pf-chips">
			// 					{field.options?.map((option) => (
			// 						<div
			// 							key={option}
			// 							className={`pf-chip ${
			// 								selectedValues.includes(option) ? "pf-chip--selected" : ""
			// 							}`}
			// 							onClick={() => toggleOption(option)}
			// 						>
			// 							{option}
			// 						</div>
			// 					))}
			// 				</div>
			// 			</Grid>
			// 		</Grid>
			// 	);
			// }

			//  MULTISELECT
			if (field.type === "multiselect") {
				let selectedValues: string[] = formData[fieldKey] || [];
				let selectedValues2: string[] = [];

				if (fieldKey === "rider.coverage_for" && formData["rider.is_rider_only_for_employee"]) {
					selectedValues2 = ["Employee Only"];
					selectedValues = selectedValues2;
				} else if (
					fieldKey === "rider.coverage_for" &&
					formData["rider.is_rider_has_same_base_plan_coverage_for"]
				) {
					selectedValues2 = Array.isArray(formData.coverage_for)
						? formData.coverage_for
						: formData.coverage_for?.options || [];

					selectedValues = selectedValues2;
				}

				let displayOptions = field.options || [];

				if (fieldKey === "coverage_for") {
					const independentRelationship = formData["indenpendent_relationship"];
					const employeeRequire = formData["employee_require"];

					// If either checkbox is true
					if (independentRelationship) {
						displayOptions = ["Employee Only", "Spouse Only", "Children Only", "Spouse & Children"];
					}
					if (independentRelationship && employeeRequire) {
						displayOptions = ["Employee Only", "Spouse Only", "Children Only", "Spouse & Children"];
					}
				}
				if (fieldKey === "rider.coverage_for") {
					const independentRelationshipRider = formData["rider.indenpendent_relationship"];

					const employeeRequire = formData["rider.employee_require"];
					if (independentRelationshipRider) {
						displayOptions = ["Employee Only", "Spouse Only", "Children Only"];
					}
					if (independentRelationshipRider && employeeRequire) {
						displayOptions = ["Employee Only", "Spouse Only", "Children Only"];
					}
				}

				const toggleOption = (option: string) => {
					let updatedValues: string[];

					if (selectedValues.includes(option)) {
						updatedValues = selectedValues.filter((v) => v !== option);
					} else {
						if (
							fieldKey === "rider.coverage_for" &&
							formData["rider.is_rider_has_same_base_plan_coverage_for"]
						) {
							updatedValues = Array.from(new Set([...selectedValues2, option]));
						} else {
							updatedValues = [...selectedValues, option];
						}
					}

					handleChange(fieldKey, updatedValues);
				};

				return (
					<Grid
						container
						spacing={2}
						key={fieldKey}
						className="pf-mui-field"
						sx={{ ...fieldContainerStyles }}
					>
						<Grid item {...labelGrid}>
							<div className="pf-label-text">{renderLabel(field.label, field.required)}</div>
						</Grid>

						<Grid item {...inputGrid}>
							<div className="pf-chips">
								{displayOptions.map((option) => (
									<div
										key={option}
										className={`pf-chip ${
											selectedValues.includes(option) ? "pf-chip--selected" : ""
										}`}
										onClick={() => toggleOption(option)}
									>
										{option}
									</div>
								))}
							</div>
						</Grid>
					</Grid>
				);
			}
			// ── FILE ─────────────────────────────────────────────────────────────────

			if (field.type === "file") {
				return (
					<Grid
						container
						spacing={2}
						key={fieldKey}
						className="pf-mui-field"
						sx={{ ...fieldContainerStyles, border: "none" }}
					>
						<Grid item {...labelGrid}>
							<div className="pf-label-text">{field.label}</div>
						</Grid>

						<Grid item {...inputGrid}>
							<label
								className={`pf-file-zone ${isDragging ? "dragging" : ""}`}
								onDragOver={(e) => {
									e.preventDefault();
									setIsDragging(true);
								}}
								onDragLeave={() => setIsDragging(false)}
								onDrop={(e) => {
									e.preventDefault();
									setIsDragging(false);

									const file = e.dataTransfer.files?.[0];
									if (!file) return;

									const ext = file.name.toLowerCase().split(".").pop();
									if (ext === "pdf") {
										setDocument(file);
									} else {
										alert("Please upload PDF only");
									}
								}}
							>
								<div className="pf-file-zone-icon">↑</div>

								<div className="pf-file-zone-text">
									<span>Choose file</span> or drag and drop
									<br />
									PDF only
								</div>

								<input
									type="file"
									accept=".pdf"
									hidden
									onChange={(e) => {
										const file = e.target.files?.[0];
										if (!file) return;

										const ext = file.name.toLowerCase().split(".").pop();
										if (ext === "pdf") {
											setDocument(file);
										} else {
											alert("Please upload PDF only");
										}
									}}
								/>
							</label>

							{/* File Preview + Remove Button */}
							{Document && (
								<div className="pf-file-preview">
									<div className="pf-file-name">{Document?.name}</div>

									<button type="button" className="pf-file-remove" onClick={() => setDocument(null)}>
										Remove
									</button>
								</div>
							)}
						</Grid>
					</Grid>
				);
			}

			// ── EXCEL FILE ────────────────────────────────────────────────────────────
			if (field.type === "excelfile") {
				return (
					<Grid
						container
						spacing={2}
						key={fieldKey}
						className="pf-mui-field"
						sx={{ ...fieldContainerStyles, border: "none" }}
					>
						<Grid item {...labelGrid}>
							<div className="pf-label-text required">{field.label}</div>
						</Grid>

						<Grid item {...inputGrid}>
							<label
								className="pf-file-zone"
								onDragOver={(e) => {
									e.preventDefault();
								}}
								onDrop={async (e) => {
									e.preventDefault();

									const droppedFile = e.dataTransfer.files?.[0];
									if (!droppedFile) return;

									const ext = droppedFile.name.toLowerCase().split(".").pop();

									setLoading(true);
									try {
										if (ext === "xlsx" || ext === "xls" || ext === "csv") {
											setIsFileChanged(true);
											setFile(droppedFile);
											await handleConvert(droppedFile);
										} else {
											alert("Please upload only Excel files (.xlsx, .xls, .csv)");
										}
									} catch (error) {
										console.error("Drop error:", error);
									} finally {
										setLoading(false);
									}
								}}
							>
								<div className="pf-file-zone-icon">↑</div>
								<div className="pf-file-zone-text">
									<span>Choose Excel file</span> or drag and drop
									<br />
									.xlsx / .xls / .csv
								</div>

								<input
									type="file"
									accept=".xlsx,.xls,.csv"
									hidden
									onChange={async (e) => {
										const selected = e.target.files?.[0];
										if (!selected) return;

										const ext = selected.name.toLowerCase().split(".").pop();

										setLoading(true);
										try {
											if (ext === "xlsx" || ext === "xls" || ext === "csv") {
												setIsFileChanged(true);
												setFile(selected);
												await handleConvert(selected);
											} else {
												alert("Please upload only Excel files (.xlsx, .xls, .csv)");
												e.target.value = "";
											}
										} catch (error) {
											console.error("File handling error:", error);
										} finally {
											setLoading(false);
										}
									}}
								/>
							</label>

							{/* File name + Remove button */}
							{file && (
								<div className="pf-file-preview">
									<span className="pf-file-name">{file.name}</span>

									<button
										type="button"
										className="pf-remove-btn"
										onClick={() => {
											setFile(null);
											setIsFileChanged(false);
										}}
									>
										Remove
									</button>
								</div>
							)}
						</Grid>
					</Grid>
				);
			}
			// ── CHECKBOX ──────────────────────────────────────────────────────────────
			if (field.type === "checkbox") {
				return (
					<Grid
						container
						spacing={2}
						key={fieldKey}
						className="pf-mui-field"
						sx={{ ...fieldContainerStyles }}
					>
						<Grid item {...labelGrid}>
							<div className="pf-label-text">{renderLabel(field.label, field.required)}</div>
						</Grid>
						<Grid item {...inputGrid}>
							<label className="pf-checkbox-wrap">
								<input
									type="checkbox"
									className="pf-checkbox"
									checked={Boolean(formData[fieldKey])}
									onChange={(e) => handleChange(fieldKey, e.target.checked)}
								/>
								{/* <span className="pf-checkbox-label">{field.label}</span> */}
							</label>
							{validation.plan[`${fieldKey}`] && (
								<div className="pf-helper">{validation.plan[`${fieldKey}`]}</div>
							)}
						</Grid>
					</Grid>
				);
			}

			// ── DATE ──────────────────────────────────────────────────────────────────
			if (field.type === "date") {
				const isEndDate = field.label?.toLowerCase().includes("end date");
				return (
					<Grid
						container
						spacing={2}
						key={fieldKey}
						className="pf-mui-field"
						sx={{ ...fieldContainerStyles }}
					>
						<Grid item {...labelGrid}>
							<div className={`pf-label-text ${!isEndDate ? "required" : ""}`}>{field.label}</div>
						</Grid>
						<Grid item {...inputGrid}>
							<MuiPickersUtilsProvider utils={DateFnsUtils}>
								<KeyboardDatePicker
									fullWidth
									size="small"
									inputVariant="outlined"
									label={field.label}
									format="MM/dd/yyyy"
									value={formData[fieldKey] ? new Date(formData[fieldKey]) : null}
									onChange={(date) =>
										handleChange(
											fieldKey,
											date
												? `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
												: null
										)
									}
									InputLabelProps={{ shrink: true }}
									keyboardIcon={<EventIcon fontSize="small" style={{ color: "var(--pf-accent)" }} />}
									KeyboardButtonProps={{
										"aria-label": "change date",
										style: { color: "var(--pf-accent)" }
									}}
									style={{ width: "100%", maxWidth: 340, borderRadius: 6 }}
									InputProps={{ style: { height: 44, padding: "11px 13px" } }}
								/>
							</MuiPickersUtilsProvider>
							{validation.plan[`${fieldKey}`] && (
								<div className="pf-helper">{validation.plan[`${fieldKey}`]}</div>
							)}
						</Grid>
					</Grid>
				);
			}

			// ── SELECT & TEXT (default) ───────────────────────────────────────────────
			return (
				<Grid container spacing={2} key={fieldKey} className="pf-mui-field" sx={{ ...fieldContainerStyles }}>
					<Grid item {...labelGrid}>
						<div className="pf-label-text">{renderLabel(field.label, field.required)}</div>
					</Grid>
					<Grid item {...inputGrid}>
						{field.type === "select" ? (
							<TextField
								select
								size="small"
								value={formData[fieldKey] || ""}
								variant="outlined"
								onChange={(e) => handleChange(fieldKey, e.target.value)}
								sx={smallInputStyle}
								InputProps={{ style: { height: 44 } }}
							>
								{field.options?.map((option) => (
									<MenuItem key={option} value={option}>
										{option}
									</MenuItem>
								))}
							</TextField>
						) : (
							<TextField
								size="small"
								type={field.type === "number" ? "number" : "text"}
								value={formData[fieldKey] ?? field.defaultValue ?? ""}
								onWheel={(e) => e.target instanceof HTMLElement && e.target.blur()}
								variant="outlined"
								onKeyDown={handleFieldKeyDown}
								onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
									const newValue = e.target.value;
									if (field.type === "number" && Number(newValue) < 0) return;
									handleChange(fieldKey, newValue);
								}}
								required={field.required}
								sx={smallInputStyle}
								InputProps={{ style: { height: 44 } }}
							/>
						)}
						{validation.plan[`${fieldKey}`] && (
							<div className="pf-helper">{validation.plan[`${fieldKey}`]}</div>
						)}
					</Grid>
				</Grid>
			);
		},
		[formData, validation, file, Document, handleConvert]
	);

	// console.log("prompt============>", prompt);

	const generateBenefitOptions = (min: number, max: number, step: number): number[] => {
		const _min = Number(min);
		const _max = Number(max);
		const _step = Number(step);

		// ✅ Guard against infinite loop / invalid array
		if (!_step || _step <= 0 || isNaN(_min) || isNaN(_max) || isNaN(_step) || _min > _max) {
			return [];
		}

		const options: number[] = [];
		for (let i = _min; i <= _max; i += _step) {
			options.push(i);
		}
		return options;
	};

	const generateSpecificAgeListOptions = (min: number, max: number) => {
		const options = [];
		for (let i = Number(min); i <= Number(max); i++) options.push(i);
		return options;
	};
	const extractNumberFromFileName = (fileName: string): string | null => {
		const match = fileName.match(/\[(\d{6})\]/);
		return match ? match[1] : null;
	};

	const handlePaste = (event: React.ClipboardEvent<HTMLDivElement>) => {
		const { name } = event.target as HTMLInputElement;
		if (
			name === FIELD_NAMES.monthly_premium ||
			name === FIELD_NAMES.weekly_premium ||
			name === FIELD_NAMES.monthly_maximum_premium ||
			name === FIELD_NAMES.weekly_maximum_premium ||
			name === FIELD_NAMES.monthly_minimum_premium ||
			name === FIELD_NAMES.weekly_minimum_premium ||
			name === FIELD_NAMES.plan_code ||
			name === FIELD_NAMES.monthly ||
			name === FIELD_NAMES.weekly
		) {
			setPasted(true);
			setTimeout(() => null, 2000);
		}
	};

	const getEmployerPremiumDeductionPayload = useCallback(
		(coverageKey: EmployerPremiumDeduction): EmployerPremiumDeduction => {
			return {
				active: coverageKey.active,
				weekly_premium: coverageKey.weekly_premium ? Number(coverageKey.weekly_premium) : null,
				monthly_premium: coverageKey.monthly_premium ? Number(coverageKey.monthly_premium) : null
			};
		},
		[]
	);

	const getCoveragePremiumPayload = useCallback((coverageKey: PremiumRateCoverage): PremiumRateCoverage => {
		return {
			active: coverageKey.active,
			weekly_premium: coverageKey.weekly_premium ? Number(coverageKey.weekly_premium) : null,
			monthly_premium: coverageKey.monthly_premium ? Number(coverageKey.monthly_premium) : null,
			weekly_maximum_premium: coverageKey.weekly_maximum_premium
				? Number(coverageKey.weekly_maximum_premium)
				: null,
			monthly_maximum_premium: coverageKey.monthly_maximum_premium
				? Number(coverageKey.monthly_maximum_premium)
				: null,
			weekly_minimum_premium: coverageKey.weekly_minimum_premium
				? Number(coverageKey.weekly_minimum_premium)
				: null,
			monthly_minimum_premium: coverageKey.monthly_minimum_premium
				? Number(coverageKey.monthly_minimum_premium)
				: null,
			premium_type: coverageKey.premium_type as PremiumType
		};
	}, []);

	const getCoveragePayload = useCallback(
		(coverage: CoverageType): CoverageType => {
			// console.log("coverage pa", coverage);
			return {
				EE: getCoveragePremiumPayload(coverage.EE),
				ES: getCoveragePremiumPayload(coverage.ES),
				EC: getCoveragePremiumPayload(coverage.EC),
				ECH: getCoveragePremiumPayload(coverage.ECH),
				ED: getCoveragePremiumPayload(coverage.ED)
			};
		},
		[getCoveragePremiumPayload]
	);

	const getEmployerDeductionPayload = useCallback(
		(employer_contribution: EmployerDeduction): EmployerDeduction => {
			return {
				EE: getEmployerPremiumDeductionPayload(employer_contribution.EE),
				ES: getEmployerPremiumDeductionPayload(employer_contribution.ES),
				EC: getEmployerPremiumDeductionPayload(employer_contribution.EC),
				ECH: getEmployerPremiumDeductionPayload(employer_contribution.ECH)
			};
		},
		[getEmployerPremiumDeductionPayload]
	);
	const createValidationCode = (): string => {
		return Math.floor(100000 + Math.random() * 900000).toString();
	};

	const handleCreatePlanClick = useCallback(async () => {
		try {
			const isvalid = handleValidation();
			console.log("hi bro", isvalid);
			if (!isvalid) return;
			// const isFormValid = handleFormValidation();
			// if (!isFormValid) return;
			const validationCode = createValidationCode();
			if (_validation?.current && _validation?.current[FIELD_NAMES.status] === VALIDATION_STATUS.invalid) {
				return;
			}
			console.log("this is the  benefit amount", formData["rider.benefit_amount.benefit_band_ranges"], formData);
			console.log("this  is the value of that field", formData["indenpendent_relationship"]);

			// Normalize pay frequency
			const normalizedPayFrequency = (formData.pay_frequency || []).map((pf: string) => pf.toUpperCase());

			// Generate benefit and age lists
			const benefitOptions = generateBenefitOptions(
				formData["benefit_amount.min_benefit"],
				formData["benefit_amount.max_benefit"],
				formData["benefit_amount.each_benefit_multiply_by"]
			);
			const spouseBenefitOptions =
				formData["benefit_amount.spouse.use_predefine_benefit"] &&
				Number(formData["benefit_amount.spouse.min_benefit"]) > 0 &&
				Number(formData["benefit_amount.spouse.max_benefit"]) > 0 &&
				Number(formData["benefit_amount.spouse.each_benefit_multiply_by"]) > 0
					? generateBenefitOptions(
							Number(formData["benefit_amount.spouse.min_benefit"]),
							Number(formData["benefit_amount.spouse.max_benefit"]),
							Number(formData["benefit_amount.spouse.each_benefit_multiply_by"])
					  )
					: [];
			const childBenefitOptions =
				formData["benefit_amount.child.use_predefine_benefit"] &&
				Number(formData["benefit_amount.child.min_benefit"]) > 0 &&
				Number(formData["benefit_amount.child.max_benefit"]) > 0 &&
				Number(formData["benefit_amount.child.each_benefit_multiply_by"]) > 0
					? generateBenefitOptions(
							Number(formData["benefit_amount.child.min_benefit"]),
							Number(formData["benefit_amount.child.max_benefit"]),
							Number(formData["benefit_amount.child.each_benefit_multiply_by"])
					  )
					: [];
			const spouseChildBenefitoption = generateBenefitOptions(
				formData["benefit_amount.child.min_benefit"],
				formData["benefit_amount.child.max_benefit"],
				formData["benefit_amount.child.each_benefit_multiply_by"]
			);
			console.log("this  is the benefit options", spouseBenefitOptions);

			const riderBenefitOptions = generateBenefitOptions(
				formData["rider.benefit_amount.min_benefit"],
				formData["rider.benefit_amount.max_benefit"],
				formData["rider.benefit_amount.each_benefit_multiply_by"]
			);

			const specificAgeList = generateSpecificAgeListOptions(
				formData["age_criteria.min_age"],
				formData["age_criteria.max_age"]
			);
			const spouseAndChildBenefitOptions = generateBenefitOptions(
				formData["benefit_amount.spouse_and_child.min_benefit"],
				formData["benefit_amount.spouse_and_child.max_benefit"],
				formData["benefit_amount.spouse_and_child.each_benefit_multiply_by"]
			);
			const riderSpouseBenefitOptions = generateBenefitOptions(
				Number(formData["rider.benefit_amount.spouse.min_benefit"]),
				Number(formData["rider.benefit_amount.spouse.max_benefit"]),
				Number(formData["rider.benefit_amount.spouse.each_benefit_multiply_by"])
			);
			const riderSpouseSpecificAge = generateSpecificAgeListOptions(
				Number(formData["rider.benefit_amount.spouse.min_age"]),
				Number(formData["rider.benefit_amount.spouse.max_age"])
			);
			const riderspecificAgeList = generateSpecificAgeListOptions(
				formData["rider.age_criteria.min_age"],
				formData["rider.age_criteria.max_age"]
			);
			const riderChildBenefitOptions = generateBenefitOptions(
				Number(formData["rider.benefit_amount.child.min_benefit"]),
				Number(formData["rider.benefit_amount.child.max_benefit"]),
				Number(formData["rider.benefit_amount.child.each_benefit_multiply_by"])
			);
			const riderChildSpecificAge = generateSpecificAgeListOptions(
				Number(formData["rider.benefit_amount.child.min_age"]),
				Number(formData["rider.benefit_amount.child.max_age"])
			);
			const spouseSpecificAge = generateSpecificAgeListOptions(
				formData["benefit_amount.spouse.min_age"],
				formData["benefit_amount.spouse.max_age"]
			);
			const specificChildAge = generateSpecificAgeListOptions(
				formData["benefit_amount.child.min_age"],
				formData["benefit_amount.child.max_age"]
			);
			const riderSpouseAndChildBenefitOptions = generateBenefitOptions(
				Number(formData["rider.benefit_amount.spouse_and_child.min_benefit"]),
				Number(formData["rider.benefit_amount.spouse_and_child.max_benefit"]),
				Number(formData["rider.benefit_amount.spouse_and_child.each_benefit_multiply_by"])
			);
			const riderSpecificAgeList = generateSpecificAgeListOptions(
				Number(formData["rider.age_criteria.min_age"]),
				Number(formData["rider.age_criteria.max_age"])
			);
			console.log(
				"this is all the age-band that i am using",
				formData["benefit_amount.spouse.max_age"],
				formData["benefit_amount.child.min_age"],
				formData["benefit_amount.spouse.options"]
			);

			// Build the payload
			const payload = {
				group_number: queryGroupNumber as number,
				plan_name: formatToTitleCase(formData.plan_name),
				plan_code: trimSpaces(formData.plan_code),
				carrier_name: formatToTitleCase(formData.carrier_name),
				plan_order: Number(formData.plan_order),
				plan_year: formData.plan_year,
				status: formData.status,
				deduction_code: formData["deduction_code"] || null,
				employee_class: formData.employee_class,
				start_date: formData.start_date,
				end_date: formData.end_date || null,
				auto_approve: formData.auto_approve || false,
				beneficiaries_required: formData.Beneficiaries || false,
				is_premium_depends_on_smoke: formData.is_premium_depends_on_smoke || false,
				is_premium_depnends_on_spouse_smoke:
					formData["benefit_amount.spouse.is_premium_depends_on_smoke"] || false,
				is_premium_depnends_on_child_smoke:
					formData["benefit_amount.child.is_premium_depends_on_smoke"] || false,

				document: Document || null,

				coverage_for: {
					options: coverageSort(formData.coverage_for || []),
					is_present: true,
					is_visible_in_form: true
				},

				// coverage_volume: {
				// 	options: formData.coverage_volume_present ? formData.coverage_volume : [],
				// 	is_present: formData.coverage_volume_present || false,
				// 	is_visible_in_form: true
				// },
				can_each_relationship_enroll_indipendently_in_this_plan: formData["indenpendent_relationship"] || false,
				employee_required: formData["employee_require"] || false,
				coverage_volume: {
					options: formData.coverage_volume_present
						? formData.coverage_volume.map((item: string) => formatToTitleCase(item))
						: [],
					is_present: formData.coverage_volume_present || false,
					is_visible_in_form: true
				},

				pay_frequency: {
					options: normalizedPayFrequency || [],
					is_present: true,
					is_visible_in_form: true
				},
				premium_amount: jsonOutput || null,

				benefit_amount: {
					is_present: formData.is_benefit || false,
					is_visible_in_form: false,

					min_benefit:
						formData.is_benefit && formData["benefit_amount.enable_specific_benefit"]
							? Number(formData["benefit_amount.min_benefit"]) || 0
							: 0,

					max_benefit:
						formData.is_benefit && formData["benefit_amount.enable_specific_benefit"]
							? Number(formData["benefit_amount.max_benefit"]) || 0
							: 0,

					each_benefit_multiply_by:
						formData.is_benefit && formData["benefit_amount.enable_specific_benefit"]
							? Number(formData["benefit_amount.each_benefit_multiply_by"]) || 0
							: 0,

					options: !formData.is_benefit
						? []
						: formData["benefit_amount.enable_specific_benefit"]
						? (benefitOptions || []).map(Number)
						: formData["benefit_amount.use_predefine_benefit"]
						? (formData["benefit_amount.benefit_band_ranges"] || []).map((x: any) => Number(x))
						: [],

					is_each_member_has_different_benefit_amount:
						formData["benefit_amount.is_each_member_has_different_benefit_amount"] || false,
					is_benefit_based_on_salary: false,

					is_benefit_amount_based_on_yearly_salary_percentage:
						formData["benefit_amount.is_benefit_amount_based_on_yearly_salary_percentage"] || false,

					salary_percentage: Number(formData["benefit_amount.salary_percentage"]) || null,

					is_benefit_amount_based_on_yearly_salary_multiplier:
						formData["benefit_amount.is_benefit_amount_based_on_yearly_salary_multiplier"] || false,
					yearly_salary_multiplier: Number(formData["benefit_amount.yearly_salary_multiplier"]) || null,

					benefit_amount_round_to_nearest:
						Number(formData["benefit_amount.benefit_amount_round_to_nearest"]) || null,

					// spouse: {
					// 	min_benefit: Number(formData["benefit_amount.spouse.min_benefit"]) || null,
					// 	each_benefit_multiply_by:
					// 		Number(formData["benefit_amount.spouse.each_benefit_multiply_by"]) || null,
					// 	max_benefit: Number(formData["benefit_amount.spouse.max_benefit"]) || null,
					// 	options: spouseBenefitOptions,

					// 	is_benefit_based_on_salary:
					// 		formData["benefit_amount.spouse.is_benefit_based_on_salary"] || false,

					// 	age_criteria: {
					// 		use_specific_ages:
					// 			formData["benefit_amount.spouse.age_criteria.use_specific_ages"] || false,
					// 		min_age: Number(formData["benefit_amount.spouse.age_criteria.min_age"]) || null,
					// 		age_step: Number(formData["benefit_amount.spouse.age_criteria.age_step"]) || null,
					// 		max_age: Number(formData["benefit_amount.spouse.age_criteria.max_age"]) || null,
					// 		specific_age_list: formData["benefit_amount.spouse.age_criteria.specific_age_list"] || [],
					// 		use_age_bands: true,
					// 		age_band_ranges: ["18-60", "61-80"]
					// 	},

					// 	salary_multiplier: Number(formData["benefit_amount.spouse.salary_multiplier"]) || null,
					// 	salary_multiplier_max_cap:
					// 		Number(formData["benefit_amount.spouse.salary_multiplier_max_cap"]) || null,
					// 	can_spouse_benefit_exceed_employee:
					// 		formData["benefit_amount.spouse.can_spouse_benefit_exceed_employee"] || false,
					// 	has_guaranteed_issue: formData["benefit_amount.spouse.has_guaranteed_issue"] || false,
					// 	guaranteed_issue_amount:
					// 		Number(formData["benefit_amount.spouse.guaranteed_issue_amount"]) || null,
					// 	requires_eoi_above_gi: false,
					// 	has_simplified_issue: formData["benefit_amount.spouse.has_simplified_issue"] || false,
					// 	simplified_issue_amount:
					// 		Number(formData["benefit_amount.spouse.simplified_issue_amount"]) || null,
					// 	requires_eoi_above_si: false,
					// 	has_si_questions: formData["benefit_amount.spouse.has_si_questions"] || false,
					// 	si_questions: formData["benefit_amount.spouse.si_questions"] || []
					// },
					spouse: {
						spouse_can_enroll_individually:
							formData["benefit_amount.spouse.spouse_can_enroll_individually"] || false,
						min_benefit: formData["benefit_amount.spouse.use_predefine_benefit"]
							? Number(formData["benefit_amount.spouse.min_benefit"]) || 0
							: 0,

						each_benefit_multiply_by: formData["benefit_amount.spouse.use_predefine_benefit"]
							? Number(formData["benefit_amount.spouse.each_benefit_multiply_by"]) || 0
							: 0,

						max_benefit: formData["benefit_amount.spouse.use_predefine_benefit"]
							? Number(formData["benefit_amount.spouse.max_benefit"]) || 0
							: 0,

						options: formData["benefit_amount.spouse.enable_specific_benefit"]
							? (formData["benefit_amount.spouse.options"] || []).map((x: any) => Number(x))
							: formData["benefit_amount.spouse.use_predefine_benefit"]
							? (spouseBenefitOptions || []).map(Number)
							: [],

						is_benefit_based_on_salary:
							formData["benefit_amount.spouse.is_benefit_based_on_salary"] || false,

						salary_multiplier: formData["benefit_amount.spouse.is_benefit_based_on_salary"]
							? Number(formData["benefit_amount.spouse.salary_multiplier"]) || null
							: null,

						salary_multiplier_max_cap: formData["benefit_amount.spouse.is_benefit_based_on_salary"]
							? Number(formData["benefit_amount.spouse.salary_multiplier_max_cap"]) || null
							: null,

						can_spouse_benefit_exceed_employee:
							formData["benefit_amount.spouse.can_spouse_benefit_exceed_employee"] || false,

						age_criteria: {
							is_present:
								formData["benefit_amount.spouse.enable_specific_ages"] ||
								formData["benefit_amount.spouse.use_age_bands"]
									? true
									: false,

							use_specific_ages:
								formData["benefit_amount.spouse.enable_specific_ages"] &&
								formData["benefit_amount.spouse.enable_specific_ages"]
									? true
									: false,

							min_age: formData["benefit_amount.spouse.enable_specific_ages"]
								? Number(formData["benefit_amount.spouse.min_age"])
								: 0,

							max_age: formData["benefit_amount.spouse.enable_specific_ages"]
								? Number(formData["benefit_amount.spouse.max_age"])
								: 0,

							age_step: 1,

							specific_age_list: formData["benefit_amount.spouse.enable_specific_ages"]
								? spouseSpecificAge
								: [],

							use_age_bands:
								formData["benefit_amount.spouse.premium_depend_on_age"] &&
								formData["benefit_amount.spouse.use_age_bands"]
									? true
									: false,

							age_band_ranges:
								formData["benefit_amount.spouse.premium_depend_on_age"] &&
								formData["benefit_amount.spouse.use_age_bands"]
									? (formData["benefit_amount.spouse.age_band_ranges"] || []).map(
											(age: any) => trimSpaces(String(age)) || 0
									  )
									: []
						},

						has_guaranteed_issue: formData["benefit_amount.spouse.has_guaranteed_issue"] || false,

						guaranteed_issue_amount: formData["benefit_amount.spouse.has_guaranteed_issue"]
							? Number(formData["benefit_amount.spouse.guaranteed_issue_amount"]) || null
							: null,

						requires_eoi_above_gi: false,

						has_simplified_issue: formData["benefit_amount.spouse.has_simplified_issue"] || false,

						simplified_issue_amount: formData["benefit_amount.spouse.has_simplified_issue"]
							? Number(formData["benefit_amount.spouse.simplified_issue_amount"]) || null
							: null,

						requires_eoi_above_si: false,

						has_si_questions:
							formData["benefit_amount.spouse.has_simplified_issue"] &&
							formData["benefit_amount.spouse.has_si_questions"]
								? true
								: false,

						si_questions: formData["benefit_amount.spouse.has_si_questions"]
							? formData["benefit_amount.spouse.si_questions"] || []
							: []
					},
					child: {
						child_can_enroll_individually:
							formData["benefit_amount.child.child_can_enroll_individually"] || false,
						min_benefit: formData["benefit_amount.child.use_predefine_benefit"]
							? Number(formData["benefit_amount.child.min_benefit"]) || 0
							: 0,

						each_benefit_multiply_by: formData["benefit_amount.child.use_predefine_benefit"]
							? Number(formData["benefit_amount.child.each_benefit_multiply_by"]) || 0
							: 0,

						max_benefit: formData["benefit_amount.child.use_predefine_benefit"]
							? Number(formData["benefit_amount.child.max_benefit"]) || 0
							: 0,

						options: formData["benefit_amount.child.enable_specific_benefit"]
							? (formData["benefit_amount.child.options"] || []).map((x: any) => Number(x))
							: formData["benefit_amount.child.use_predefine_benefit"]
							? (childBenefitOptions || []).map(Number)
							: [],

						is_benefit_based_on_salary:
							formData["benefit_amount.child.is_benefit_based_on_salary"] || false,

						salary_multiplier: formData["benefit_amount.child.is_benefit_based_on_salary"]
							? Number(formData["benefit_amount.child.salary_multiplier"]) || null
							: null,

						salary_multiplier_max_cap: formData["benefit_amount.child.is_benefit_based_on_salary"]
							? Number(formData["benefit_amount.child.salary_multiplier_max_cap"]) || null
							: null,

						can_child_benefit_exceed_employee:
							formData["benefit_amount.child.can_child_benefit_exceed_employee"] || false,

						age_criteria: {
							is_present:
								formData["benefit_amount.child.enable_specific_ages"] ||
								formData["benefit_amount.child.use_age_bands"]
									? true
									: false,

							use_specific_ages: formData["benefit_amount.child.enable_specific_ages"] ? true : false,

							min_age: formData["benefit_amount.child.enable_specific_ages"]
								? Number(formData["benefit_amount.child.min_age"])
								: 0,

							max_age: formData["benefit_amount.child.enable_specific_ages"]
								? Number(formData["benefit_amount.child.max_age"])
								: 0,

							age_step: 1,

							specific_age_list: formData["benefit_amount.child.enable_specific_ages"]
								? Array.isArray(specificChildAge)
									? specificChildAge
									: []
								: [],

							use_age_bands:
								formData["benefit_amount.child.premium_depend_on_age"] &&
								formData["benefit_amount.child.use_age_bands"]
									? true
									: false,

							age_band_ranges:
								formData["benefit_amount.child.premium_depend_on_age"] &&
								formData["benefit_amount.child.use_age_bands"]
									? (formData["benefit_amount.child.age_band_ranges"] || []).map(
											(age: any) => trimSpaces(String(age)) || 0
									  )
									: []
						},

						has_guaranteed_issue: formData["benefit_amount.child.has_guaranteed_issue"] || false,

						guaranteed_issue_amount: formData["benefit_amount.child.has_guaranteed_issue"]
							? Number(formData["benefit_amount.child.guaranteed_issue_amount"]) || null
							: null,

						requires_eoi_above_gi: false,

						has_simplified_issue: formData["benefit_amount.child.has_simplified_issue"] || false,

						simplified_issue_amount: formData["benefit_amount.child.has_simplified_issue"]
							? Number(formData["benefit_amount.child.simplified_issue_amount"]) || null
							: null,

						requires_eoi_above_si: false,

						has_si_questions:
							formData["benefit_amount.child.has_simplified_issue"] &&
							formData["benefit_amount.child.has_si_questions"]
								? true
								: false,

						si_questions: formData["benefit_amount.child.has_si_questions"]
							? formData["benefit_amount.child.si_questions"] || []
							: []
					},
					spouse_and_child: {
						min_benefit: formData["benefit_amount.spouse_and_child.use_predefine_benefit"]
							? Number(formData["benefit_amount.spouse_and_child.min_benefit"]) || 0
							: 0,

						each_benefit_multiply_by: formData["benefit_amount.spouse_and_child.use_predefine_benefit"]
							? Number(formData["benefit_amount.spouse_and_child.each_benefit_multiply_by"]) || 0
							: 0,

						max_benefit: formData["benefit_amount.spouse_and_child.use_predefine_benefit"]
							? Number(formData["benefit_amount.spouse_and_child.max_benefit"]) || 0
							: 0,

						options: formData["benefit_amount.spouse_and_child.enable_specific_benefit"]
							? (formData["benefit_amount.spouse_and_child.options"] || []).map((x: any) => Number(x))
							: formData["benefit_amount.spouse_and_child.use_predefine_benefit"]
							? (spouseAndChildBenefitOptions || []).map(Number)
							: [],

						is_benefit_based_on_salary:
							formData["benefit_amount.spouse_and_child.is_benefit_based_on_salary"] || false,

						salary_multiplier: formData["benefit_amount.spouse_and_child.is_benefit_based_on_salary"]
							? Number(formData["benefit_amount.spouse_and_child.salary_multiplier"]) || null
							: null,

						salary_multiplier_max_cap: formData[
							"benefit_amount.spouse_and_child.is_benefit_based_on_salary"
						]
							? Number(formData["benefit_amount.spouse_and_child.salary_multiplier_max_cap"]) || null
							: null,

						can_spouse_and_child_benefit_exceed_employee:
							formData["benefit_amount.spouse_and_child.can_spouse_and_child_benefit_exceed_employee"] ||
							false,

						age_criteria: {
							is_present:
								formData["benefit_amount.spouse_and_child.enable_specific_ages"] ||
								formData["benefit_amount.spouse_and_child.use_age_bands"]
									? true
									: false,

							use_specific_ages: formData["benefit_amount.spouse_and_child.enable_specific_ages"]
								? true
								: false,

							min_age: formData["benefit_amount.spouse_and_child.enable_specific_ages"]
								? Number(formData["benefit_amount.spouse_and_child.min_age"])
								: 0,

							max_age: formData["benefit_amount.spouse_and_child.enable_specific_ages"]
								? Number(formData["benefit_amount.spouse_and_child.max_age"])
								: 0,

							age_step: 1,

							specific_age_list: formData["benefit_amount.spouse_and_child.enable_specific_ages"]
								? Array.isArray(formData["benefit_amount.spouse_and_child.specific_age_list"])
									? formData["benefit_amount.spouse_and_child.specific_age_list"]
									: []
								: [],

							use_age_bands:
								formData["benefit_amount.spouse_and_child.premium_depend_on_age"] &&
								formData["benefit_amount.spouse_and_child.use_age_bands"]
									? true
									: false,

							age_band_ranges:
								formData["benefit_amount.spouse_and_child.premium_depend_on_age"] &&
								formData["benefit_amount.spouse_and_child.use_age_bands"]
									? (formData["benefit_amount.spouse_and_child.age_band_ranges"] || []).map(
											(age: any) => trimSpaces(String(age)) || 0
									  )
									: []
						},

						has_guaranteed_issue: formData["benefit_amount.spouse_and_child.has_guaranteed_issue"] || false,

						guaranteed_issue_amount: formData["benefit_amount.spouse_and_child.has_guaranteed_issue"]
							? Number(formData["benefit_amount.spouse_and_child.guaranteed_issue_amount"]) || null
							: null,

						requires_eoi_above_gi: false,

						has_simplified_issue: formData["benefit_amount.spouse_and_child.has_simplified_issue"] || false,

						simplified_issue_amount: formData["benefit_amount.spouse_and_child.has_simplified_issue"]
							? Number(formData["benefit_amount.spouse_and_child.simplified_issue_amount"]) || null
							: null,

						requires_eoi_above_si: false,

						has_si_questions:
							formData["benefit_amount.spouse_and_child.has_simplified_issue"] &&
							formData["benefit_amount.spouse_and_child.has_si_questions"]
								? true
								: false,

						si_questions: formData["benefit_amount.spouse_and_child.has_si_questions"]
							? formData["benefit_amount.spouse_and_child.si_questions"] || []
							: []
					}
				},

				// is_this_plan_has_age_criteria: formData.age_criteria?.is_present || false,
				age_criteria: {
					is_present: formData["is_this_plan_has_age_criteria"] || false,
					is_visible_in_form: false,

					use_specific_ages:
						formData["is_this_plan_has_age_criteria"] && formData["age_criteria.enable_specific_ages"]
							? true
							: false,

					min_age:
						formData["is_this_plan_has_age_criteria"] && formData["age_criteria.enable_specific_ages"]
							? Number(formData["age_criteria.min_age"])
							: 0,

					max_age:
						formData["is_this_plan_has_age_criteria"] && formData["age_criteria.enable_specific_ages"]
							? Number(formData["age_criteria.max_age"])
							: 0,

					age_step: 1,

					specific_age_list:
						formData["is_this_plan_has_age_criteria"] &&
						formData["age_criteria.enable_specific_ages"] &&
						Array.isArray(specificAgeList)
							? specificAgeList
							: [],

					use_age_bands:
						formData["is_this_plan_has_age_criteria"] && formData["age_criteria.use_age_bands"]
							? true
							: false,

					age_band_ranges:
						formData["is_this_plan_has_age_criteria"] && formData["age_criteria.use_age_bands"]
							? (formData["age_criteria.age_band_ranges"] || []).map(
									(age: any) => trimSpaces(String(age)) || 0
							  )
							: []
				},
				employee_eligibility: {
					is_visible_in_form: formData.employee_eligibility?.is_visible_in_form || false,
					employee: {
						min_age: formData["employee_eligibility.min_age"] || 16,
						max_age: formData["employee_eligibility.max_age"] || 100
					}
				},

				dependent_eligibility: {
					is_present: !!formData.isdependent_eligibility,
					is_visible_in_form: false,
					is_each_relationship_has_diffrent_premium: formData["has_dependent_eligibility"] || false,

					spouse: {
						min_age: Number(formData?.["dependent_eligibility.spouse.min_age"]) || 18,
						max_age: Number(formData?.["dependent_eligibility.spouse.max_age"]) || 100,
						can_spouse_has_max_benefit_amount_than_employee:
							!!formData?.["dependent_eligibility.spouse.can_spouse_has_max_benefit_amount_than_employee"]
					},
					children: {
						min_age: Number(formData?.["dependent_eligibility.children.min_age"]) || 0,
						max_age: Number(formData?.["dependent_eligibility.children.max_age"]) || 26,
						can_children_has_max_benefit_amount_than_employee:
							!!formData?.[
								"dependent_eligibility.children.can_children_has_max_benefit_amount_than_employee"
							],
						disabled: {
							min_age: Number(formData?.["dependent_eligibility.disabled.min_age"]) || 0,
							max_age: Number(formData?.["dependent_eligibility.disabled.max_age"]) || 100,
							children_can_exceed_employee_benefit:
								!!formData?.[
									"dependent_eligibility.children.disabled.children_can_exceed_employee_benefit"
								]
						}
					},
					eligible_relationship: Array.isArray(formData?.["dependent_eligibility.eligible_relationship"])
						? formData["dependent_eligibility.eligible_relationship"]
						: [],
					in_eligible_relationship: Array.isArray(
						formData?.["dependent_eligibility.in_eligible_relationship"]
					)
						? formData["dependent_eligibility.in_eligible_relationship"]
						: []
				},

				is_this_plan_has_riders: !!formData.is_this_plan_has_riders,
				rider: {
					is_present: formData.is_this_plan_has_riders || false,
					is_visible_in_form: true,
					beneficiaries_required: formData["rider.Beneficiaries"] || false,
					// ── Basic Info ──
					name: formatToTitleCase(formData["rider.name"]) || "",
					is_rider_only_for_employee: formData["rider.is_rider_only_for_employee"] || false,
					is_required: formData["rider.is_required"] || false,
					is_rider_has_same_base_plan_coverage_for:
						formData["rider.is_rider_has_same_base_plan_coverage_for"] || false,

					// ── Coverage ──
					can_each_relationship_enroll_indipendently_in_this_plan:
						formData["rider.indenpendent_relationship"] || false,
					employee_required: formData["rider.employee_require"] || false,

					coverage_for: {
						options: coverageSort(
							formData["rider.is_rider_only_for_employee"]
								? ["Employee Only"]
								: formData["rider.is_rider_has_same_base_plan_coverage_for"]
								? formData.coverage_for
								: formData["rider.coverage_for"] || []
						),
						is_present: true,
						is_visible_in_form: true
					},

					coverage_volume: {
						options: formData["rider.coverage_volume_present"]
							? (formData["rider.coverage_volume"] || []).map((item: string) => formatToTitleCase(item))
							: [],
						is_present: formData["rider.coverage_volume_present"] || false,
						is_visible_in_form: true
					},

					coverage_volume_same_as_employee: formData["rider.coverage_volume_same_as_employee"] || false,

					pay_frequency: {
						options: formData["rider.pay_frequency"] || [],
						is_present: true,
						is_visible_in_form: true
					},

					is_premium_depends_on_smoke: formData["rider.is_premium_depends_on_smoke"] || false,
					is_premium_depnends_on_spouse_smoke:
						formData["rider.benefit_amount.spouse.is_premium_depends_on_smoke"] || false,
					is_premium_depnends_on_child_smoke:
						formData["rider.benefit_amount.child.is_premium_depends_on_smoke"] || false,

					// ── Benefit Amount ──
					benefit_amount: {
						is_present: formData["rider.is_benefit"] || false,
						is_visible_in_form: false,

						min_benefit:
							formData["rider.is_benefit"] && formData["rider.benefit_amount.enable_specific_benefit"]
								? Number(formData["rider.benefit_amount.min_benefit"]) || 0
								: 0,

						max_benefit:
							formData["rider.is_benefit"] && formData["rider.benefit_amount.enable_specific_benefit"]
								? Number(formData["rider.benefit_amount.max_benefit"]) || 0
								: 0,

						each_benefit_multiply_by:
							formData["rider.is_benefit"] && formData["rider.benefit_amount.enable_specific_benefit"]
								? Number(formData["rider.benefit_amount.each_benefit_multiply_by"]) || 0
								: 0,

						options: !formData["rider.is_benefit"]
							? []
							: formData["rider.benefit_amount.enable_specific_benefit"]
							? (riderBenefitOptions || []).map(Number)
							: formData["rider.benefit_amount.use_predefine_benefit"]
							? (formData["rider.benefit_amount.benefit_band_ranges"] || []).map((x: any) => Number(x))
							: [],

						benefit_amount_round_to_nearest:
							Number(formData["rider.benefit_amount.benefit_amount_round_to_nearest"]) || null,

						is_each_member_has_different_benefit_amount:
							formData["rider.benefit_amount.is_each_member_has_different_benefit_amount"] || false,

						// ── Salary ──
						is_benefit_based_on_salary:
							formData["rider.benefit_amount.is_benefit_based_on_salary"] || false,

						is_benefit_amount_based_on_yearly_salary_percentage:
							formData["rider.benefit_amount.is_benefit_amount_based_on_yearly_salary_percentage"] ||
							false,

						salary_percentage: formData[
							"rider.benefit_amount.is_benefit_amount_based_on_yearly_salary_percentage"
						]
							? Number(formData["rider.benefit_amount.salary_percentage"]) || null
							: null,

						is_benefit_amount_based_on_yearly_salary_multiplier:
							formData["rider.benefit_amount.is_benefit_amount_based_on_yearly_salary_multiplier"] ||
							false,

						yearly_salary_multiplier: formData[
							"rider.benefit_amount.is_benefit_amount_based_on_yearly_salary_multiplier"
						]
							? Number(formData["rider.benefit_amount.yearly_salary_multiplier"]) || null
							: null,

						salary_multiplier_max_cap: formData[
							"rider.benefit_amount.is_benefit_amount_based_on_yearly_salary_multiplier"
						]
							? Number(formData["rider.benefit_amount.salary_multiplier_max_cap"]) || null
							: null,

						// ── Spouse ──
						spouse: {
							spouse_can_enroll_individually:
								formData["rider.benefit_amount.spouse.spouse_can_enroll_individually"] || false,

							min_benefit: formData["rider.benefit_amount.spouse.use_predefine_benefit"]
								? Number(formData["rider.benefit_amount.spouse.min_benefit"]) || 0
								: 0,

							each_benefit_multiply_by: formData["rider.benefit_amount.spouse.use_predefine_benefit"]
								? Number(formData["rider.benefit_amount.spouse.each_benefit_multiply_by"]) || 0
								: 0,

							max_benefit: formData["rider.benefit_amount.spouse.use_predefine_benefit"]
								? Number(formData["rider.benefit_amount.spouse.max_benefit"]) || 0
								: 0,

							options: formData["rider.benefit_amount.spouse.enable_specific_benefit"]
								? (formData["rider.benefit_amount.spouse.options"] || []).map((x: any) => Number(x))
								: formData["rider.benefit_amount.spouse.use_predefine_benefit"]
								? (riderSpouseBenefitOptions || []).map(Number)
								: [],

							is_benefit_based_on_salary:
								formData["rider.benefit_amount.spouse.is_benefit_based_on_salary"] || false,

							salary_multiplier: formData["rider.benefit_amount.spouse.is_benefit_based_on_salary"]
								? Number(formData["rider.benefit_amount.spouse.salary_multiplier"]) || null
								: null,

							salary_multiplier_max_cap: formData[
								"rider.benefit_amount.spouse.is_benefit_based_on_salary"
							]
								? Number(formData["rider.benefit_amount.spouse.salary_multiplier_max_cap"]) || null
								: null,

							can_spouse_benefit_exceed_employee:
								formData["rider.benefit_amount.spouse.can_spouse_benefit_exceed_employee"] || false,

							age_criteria: {
								is_present:
									formData["rider.benefit_amount.spouse.enable_specific_ages"] ||
									formData["rider.benefit_amount.spouse.use_age_bands"]
										? true
										: false,

								use_specific_ages: formData["rider.benefit_amount.spouse.enable_specific_ages"]
									? true
									: false,

								min_age: formData["rider.benefit_amount.spouse.enable_specific_ages"]
									? Number(formData["rider.benefit_amount.spouse.min_age"])
									: 0,

								max_age: formData["rider.benefit_amount.spouse.enable_specific_ages"]
									? Number(formData["rider.benefit_amount.spouse.max_age"])
									: 0,

								age_step: 1,

								specific_age_list: formData["rider.benefit_amount.spouse.enable_specific_ages"]
									? riderSpouseSpecificAge || []
									: [],

								use_age_bands:
									formData["rider.benefit_amount.spouse.premium_depend_on_age"] &&
									formData["rider.benefit_amount.spouse.use_age_bands"]
										? true
										: false,

								age_band_ranges:
									formData["rider.benefit_amount.spouse.premium_depend_on_age"] &&
									formData["rider.benefit_amount.spouse.use_age_bands"]
										? (formData["rider.benefit_amount.spouse.age_band_ranges"] || []).map(
												(age: any) => trimSpaces(String(age)) || 0
										  )
										: []
							},

							has_guaranteed_issue: formData["rider.benefit_amount.spouse.has_guaranteed_issue"] || false,

							guaranteed_issue_amount: formData["rider.benefit_amount.spouse.has_guaranteed_issue"]
								? Number(formData["rider.benefit_amount.spouse.guaranteed_issue_amount"]) || null
								: null,

							requires_eoi_above_gi: false,

							has_simplified_issue: formData["rider.benefit_amount.spouse.has_simplified_issue"] || false,

							simplified_issue_amount: formData["rider.benefit_amount.spouse.has_simplified_issue"]
								? Number(formData["rider.benefit_amount.spouse.simplified_issue_amount"]) || null
								: null,

							requires_eoi_above_si: false,

							has_si_questions:
								formData["rider.benefit_amount.spouse.has_simplified_issue"] &&
								formData["rider.benefit_amount.spouse.has_si_questions"]
									? true
									: false,

							si_questions: formData["rider.benefit_amount.spouse.has_si_questions"]
								? formData["rider.benefit_amount.spouse.si_questions"] || []
								: []
						},

						// ── Child ──
						child: {
							child_can_enroll_individually:
								formData["rider.benefit_amount.child.child_can_enroll_individually"] || false,

							min_benefit: formData["rider.benefit_amount.child.use_predefine_benefit"]
								? Number(formData["rider.benefit_amount.child.min_benefit"]) || 0
								: 0,

							each_benefit_multiply_by: formData["rider.benefit_amount.child.use_predefine_benefit"]
								? Number(formData["rider.benefit_amount.child.each_benefit_multiply_by"]) || 0
								: 0,

							max_benefit: formData["rider.benefit_amount.child.use_predefine_benefit"]
								? Number(formData["rider.benefit_amount.child.max_benefit"]) || 0
								: 0,

							options: formData["rider.benefit_amount.child.enable_specific_benefit"]
								? (formData["rider.benefit_amount.child.options"] || []).map((x: any) => Number(x))
								: formData["rider.benefit_amount.child.use_predefine_benefit"]
								? (riderChildBenefitOptions || []).map(Number)
								: [],

							is_benefit_based_on_salary:
								formData["rider.benefit_amount.child.is_benefit_based_on_salary"] || false,

							salary_multiplier: formData["rider.benefit_amount.child.is_benefit_based_on_salary"]
								? Number(formData["rider.benefit_amount.child.salary_multiplier"]) || null
								: null,

							salary_multiplier_max_cap: formData["rider.benefit_amount.child.is_benefit_based_on_salary"]
								? Number(formData["rider.benefit_amount.child.salary_multiplier_max_cap"]) || null
								: null,

							can_child_benefit_exceed_employee:
								formData["rider.benefit_amount.child.can_child_benefit_exceed_employee"] || false,

							age_criteria: {
								is_present:
									formData["rider.benefit_amount.child.enable_specific_ages"] ||
									formData["rider.benefit_amount.child.use_age_bands"]
										? true
										: false,

								use_specific_ages: formData["rider.benefit_amount.child.enable_specific_ages"]
									? true
									: false,

								min_age: formData["rider.benefit_amount.child.enable_specific_ages"]
									? Number(formData["rider.benefit_amount.child.min_age"])
									: 0,

								max_age: formData["rider.benefit_amount.child.enable_specific_ages"]
									? Number(formData["rider.benefit_amount.child.max_age"])
									: 0,

								age_step: 1,

								specific_age_list: formData["rider.benefit_amount.child.enable_specific_ages"]
									? Array.isArray(riderChildSpecificAge)
										? riderChildSpecificAge
										: []
									: [],

								use_age_bands:
									formData["rider.benefit_amount.child.premium_depend_on_age"] &&
									formData["rider.benefit_amount.child.use_age_bands"]
										? true
										: false,

								age_band_ranges:
									formData["rider.benefit_amount.child.premium_depend_on_age"] &&
									formData["rider.benefit_amount.child.use_age_bands"]
										? (formData["rider.benefit_amount.child.age_band_ranges"] || []).map(
												(age: any) => trimSpaces(String(age)) || 0
										  )
										: []
							},

							has_guaranteed_issue: formData["rider.benefit_amount.child.has_guaranteed_issue"] || false,

							guaranteed_issue_amount: formData["rider.benefit_amount.child.has_guaranteed_issue"]
								? Number(formData["rider.benefit_amount.child.guaranteed_issue_amount"]) || null
								: null,

							requires_eoi_above_gi: false,

							has_simplified_issue: formData["rider.benefit_amount.child.has_simplified_issue"] || false,

							simplified_issue_amount: formData["rider.benefit_amount.child.has_simplified_issue"]
								? Number(formData["rider.benefit_amount.child.simplified_issue_amount"]) || null
								: null,

							requires_eoi_above_si: false,

							has_si_questions:
								formData["rider.benefit_amount.child.has_simplified_issue"] &&
								formData["rider.benefit_amount.child.has_si_questions"]
									? true
									: false,

							si_questions: formData["rider.benefit_amount.child.has_si_questions"]
								? formData["rider.benefit_amount.child.si_questions"] || []
								: []
						},

						// ── Spouse & Child ──
						spouse_and_child: {
							min_benefit: formData["rider.benefit_amount.spouse_and_child.enable_specific_benefit"]
								? Number(formData["rider.benefit_amount.spouse_and_child.min_benefit"]) || 0
								: 0,

							each_benefit_multiply_by: formData[
								"rider.benefit_amount.spouse_and_child.enable_specific_benefit"
							]
								? Number(formData["rider.benefit_amount.spouse_and_child.each_benefit_multiply_by"]) ||
								  0
								: 0,

							max_benefit: formData["rider.benefit_amount.spouse_and_child.enable_specific_benefit"]
								? Number(formData["rider.benefit_amount.spouse_and_child.max_benefit"]) || 0
								: 0,

							benefit_amount_round_to_nearest:
								Number(
									formData["rider.benefit_amount.spouse_and_child.benefit_amount_round_to_nearest"]
								) || null,

							options: formData["rider.benefit_amount.spouse_and_child.enable_specific_benefit"]
								? (riderSpouseAndChildBenefitOptions || []).map(Number)
								: formData["rider.benefit_amount.spouse_and_child.use_predefine_benefit"]
								? (formData["rider.benefit_amount.spouse_and_child.benefit_band_ranges"] || []).map(
										(x: any) => Number(x)
								  )
								: [],

							use_employee_benefit:
								formData["rider.benefit_amount.spouse_and_child.use_employee_benefit"] || false,
							use_spouse_benefit:
								formData["rider.benefit_amount.spouse_and_child.use_spouse_benefit"] || false,
							use_child_benefit:
								formData["rider.benefit_amount.spouse_and_child.use_child_benefit"] || false,
							use_separate_benefit:
								formData["rider.benefit_amount.spouse_and_child.use_separate_benefit"] || false
						}
					},

					// ── Paycheck + Employee-level GI/SI (mirrors standard plan) ──
					is_benefit_dependent_on_paycheck:
						formData["rider.is_benefit"] && formData["rider.is_benefit_dependent_on_paycheck"]
							? true
							: false,

					has_guaranteed_issue: formData["rider.has_guaranteed_issue"] || false,

					guaranteed_issue_amount: formData["rider.has_guaranteed_issue"]
						? Number(formData["rider.guaranteed_issue_amount"]) || null
						: null,

					has_simplified_issue: formData["rider.has_simplified_issue"] || false,

					simplified_issue_amount: formData["rider.has_simplified_issue"]
						? Number(formData["rider.simplified_issue_amount"]) || null
						: null,

					has_si_questions:
						formData["rider.has_simplified_issue"] && formData["rider.has_si_questions"] ? true : false,

					si_questions: formData["rider.has_si_questions"] ? formData["rider.si_questions"] || [] : [],

					// ── Age Criteria ──
					age_criteria: {
						is_present: formData["rider.is_this_plan_has_age_criteria"] || false,
						is_visible_in_form: false,

						use_specific_ages:
							formData["rider.is_this_plan_has_age_criteria"] &&
							formData["rider.age_criteria.enable_specific_ages"]
								? true
								: false,

						min_age:
							formData["rider.is_this_plan_has_age_criteria"] &&
							formData["rider.age_criteria.enable_specific_ages"]
								? Number(formData["rider.age_criteria.min_age"])
								: 0,

						max_age:
							formData["rider.is_this_plan_has_age_criteria"] &&
							formData["rider.age_criteria.enable_specific_ages"]
								? Number(formData["rider.age_criteria.max_age"])
								: 0,

						age_step: 1,

						specific_age_list:
							formData["rider.is_this_plan_has_age_criteria"] &&
							formData["rider.age_criteria.enable_specific_ages"] &&
							Array.isArray(riderSpecificAgeList)
								? riderSpecificAgeList
								: [],

						use_age_bands:
							formData["rider.is_this_plan_has_age_criteria"] &&
							formData["rider.age_criteria.use_age_bands"]
								? true
								: false,

						age_band_ranges:
							formData["rider.is_this_plan_has_age_criteria"] &&
							formData["rider.age_criteria.use_age_bands"]
								? (formData["rider.age_criteria.age_band_ranges"] || []).map(
										(age: any) => trimSpaces(String(age)) || 0
								  )
								: []
					},

					// ── Employee Eligibility ──
					employee_eligibility: {
						is_visible_in_form: false,
						employee: {
							min_age: formData["rider.employee_eligibility.min_age"] || 16,
							max_age: formData["rider.employee_eligibility.max_age"] || 100
						}
					},

					// ── Dependent Eligibility ──
					isriderdependent_eligibility: formData["rider.isdependent_eligibility"] || false,

					dependent_eligibility: {
						is_present: formData["rider.isdependent_eligibility"] || false,
						is_visible_in_form: false,
						is_each_relationship_has_diffrent_premium: false,

						eligible_relationship: Array.isArray(
							formData["rider.dependent_eligibility.eligible_relationship"]
						)
							? formData["rider.dependent_eligibility.eligible_relationship"]
							: [],

						in_eligible_relationship: Array.isArray(
							formData["rider.dependent_eligibility.in_eligible_relationship"]
						)
							? formData["rider.dependent_eligibility.in_eligible_relationship"]
							: [],

						spouse: {
							min_age: Number(formData["rider.dependent_eligibility.spouse.min_age"]) || 18,
							max_age: Number(formData["rider.dependent_eligibility.spouse.max_age"]) || 100,
							can_spouse_has_max_benefit_amount_than_employee:
								formData[
									"rider.dependent_eligibility.spouse.can_spouse_has_max_benefit_amount_than_employee"
								] || false
						},

						children: {
							min_age: Number(formData["rider.dependent_eligibility.children.min_age"]) || 0,
							max_age: Number(formData["rider.dependent_eligibility.children.max_age"]) || 26,
							can_children_has_max_benefit_amount_than_employee:
								formData[
									"rider.dependent_eligibility.children.can_children_has_max_benefit_amount_than_employee"
								] || false,
							disabled: {
								min_age: Number(formData["rider.dependent_eligibility.disabled.min_age"]) || 0,
								max_age: Number(formData["rider.dependent_eligibility.disabled.max_age"]) || 100,
								children_can_exceed_employee_benefit:
									formData[
										"rider.dependent_eligibility.disabled.children_can_exceed_employee_benefit"
									] || false
							}
						}
					}
				},
				has_guaranteed_issue: formData["has_guaranteed_issue"] || false,

				guaranteed_issue_amount: formData["has_guaranteed_issue"]
					? Number(formData["guaranteed_issue_amount"]) || null
					: null,

				requires_eoi_above_gi: false,

				has_simplified_issue: formData["has_simplified_issue"] || false,

				simplified_issue_amount: formData["has_simplified_issue"]
					? Number(formData["simplified_issue_amount"]) || null
					: null,

				requires_eoi_above_si: false,

				has_si_questions: formData["has_simplified_issue"] && formData["has_si_questions"] ? true : false,

				si_questions: formData["has_si_questions"] ? formData["si_questions"] || [] : [],

				step: step,
				excel_validation_code: 1457891,
				rider_plan_dependency: formData["rider_plan_dependency"],
				standard_plan_dependency: formData["standard_plan_dependency"],
				has_general_question: formData["has_questions"] || false,
				general_questions: formData["questions"] || []
			};

			const safePayload = JSON.parse(JSON.stringify(payload));

			const formDataPayload = new FormData();
			formDataPayload.append("plan", JSON.stringify(safePayload));
			if (Document) {
				formDataPayload.append("document", Document as unknown as File);
			}
			console.log("this is the form data", formData);
			const createdPlan: VEB_Plan = await trackPromise(api.plan.addVEBPlan(formDataPayload));
			const planID = createdPlan._id;
			setPlanId(planID);
			// if (!createdPlan) {
			// 	setStep(5);
			// 	return false;
			// }
			setCurrentplan(createdPlan);

			const excelPayload = {
				carrier_name: {
					value: safePayload.plan_name,
					type: "string",
					is_present: true,
					is_visible_in_form: true
				},
				auto_approve: safePayload.auto_approve,
				is_premium_depends_on_smoke: formData["is_premium_depends_on_smoke"] || false,
				is_premium_depnends_on_spouse_smoke: safePayload.is_premium_depnends_on_spouse_smoke,
				is_premium_depnends_on_child_smoke: safePayload.is_premium_depnends_on_child_smoke,
				coverage_for: safePayload.coverage_for,
				coverage_volume: safePayload.coverage_volume,
				pay_frequency: safePayload.pay_frequency,
				premium_amount: safePayload.premium_amount,
				benefit_amount: safePayload.benefit_amount,
				is_this_plan_has_age_criteria: safePayload.age_criteria.is_present,
				age_criteria: safePayload.age_criteria,
				dependent_eligibility: safePayload.dependent_eligibility,
				is_this_plan_has_riders: safePayload.is_this_plan_has_riders,
				can_each_relationship_enroll_indipendently_in_this_plan:
					safePayload.can_each_relationship_enroll_indipendently_in_this_plan || false,
				rider: safePayload.rider
			};
			excelPayloadRef.current = excelPayload;
			setExcelPayload(JSON.parse(JSON.stringify(payload)));
			// if (step == 4) {
			// 	await jsonToExcel(`${createdPlan.plan_name}_PREMIUM.xlsx`, excelPayload);
			// }
			// await jsonToExcel(`${createdPlan.plan_name}_PREMIUM[${1457891}].xlsx`, excelPayload);
			await jsonToExcel(`${safePayload.plan_name}[${validationCode}].xlsx`, excelPayload);

			// if (createdPlan) {
			// 	alert("Plan is saved as draft");
			// }
			return true;
		} catch (err: any) {
			console.error(err);
			alert(err.response?.data?.message || "Failed to create plan");
		}
	}, [formData, plan, queryGroupNumber, navigate, handleValidation, step]);

	const handlePlanChange = useCallback(
		(
			event: React.ChangeEvent<HTMLInputElement | { name?: string | undefined; value: unknown }>,
			child?: React.ReactNode
		) => {
			//alert("asd");
			const { name, value } = event.target;
			// console.log("planadsasdasd", name, value);
			let _value: any = value;
			if (name === "plan_code" && typeof value === "string") {
				if (!pasted) {
					if (!/^[a-zA-Z0-9 -]*$/.test(value)) {
						event.target.value = "";
						if (plan) _value = plan[name];
					}
				} else {
					setPasted(false);
					if (!/^[a-zA-Z0-9 -]*$/.test(value)) {
						_value = value.replace(/[^a-zA-Z0-9-]+/g, "").toUpperCase();
					}
				}

				setPlan(Object.assign({}, plan, { [name]: _value.toUpperCase() }));
			} else {
				setPlan(Object.assign({}, plan, { [name as string]: value }));
			}
		},
		[pasted, plan]
	);
	// const GreenStepIcon = (props: StepIconProps) => {
	// 	const { completed, active, icon } = props;

	// 	const circleStyle: React.CSSProperties = {
	// 		width: 30,
	// 		height: 30,
	// 		borderRadius: "50%",
	// 		display: "flex",
	// 		justifyContent: "center",
	// 		alignItems: "center",
	// 		fontSize: 18,
	// 		fontWeight: 600,
	// 		color: "white",
	// 		background: completed
	// 			? "linear-gradient(135deg, #4caf50, #2e7d32)"
	// 			: active
	// 			? "linear-gradient(135deg, #81c784, #4caf50)"
	// 			: "#bdbdbd",
	// 		border: "2px solid rgba(0,0,0,0.1)",
	// 		boxShadow: active ? "0 0 12px rgba(76, 175, 80, 0.6)" : "0 2px 6px rgba(0,0,0,0.15)",
	// 		transition: "all 0.3s ease, transform 0.2s ease",
	// 		transform: active ? "scale(1.1)" : "scale(1)"
	// 	};

	// 	return <div style={circleStyle}>{completed ? <Check style={{ fontSize: 24 }} /> : icon}</div>;
	// };
	const updateAllplanOrder = useCallback(async () => {
		//console.log("Updating plans", planOrderList);

		if (!planOrderList.length) return;

		const results = await Promise.allSettled(
			planOrderList.map((plan) => {
				if (!plan.planID || plan.planOrder == null) {
					return Promise.resolve(null);
				}

				return trackPromise(
					api.plan.updateVEBPlanOrder(plan.planID, {
						plan_order: Number(plan.planOrder)
					})
				);
			})
		);

		//console.log("Update result", results);
	}, [planOrderList]);

	//console.log("hi from the 123 plans", activePlans);

	const handleCancel = () => {
		setShiftAndMoveToLastPlanOrder({ moveToLast: false, shift: false });
		setShowModal(false);
	};

	const handleMoveToPosition = useCallback(
		(targetOrder: number) => {
			if (!targetOrder || planOrderList.length === 0) return;

			const sorted = [...planOrderList].sort((a, b) => a.planOrder - b.planOrder);

			let firstConflictIndex = -1;

			//  Shift & capture FIRST conflict
			for (let i = 0; i < sorted.length; i++) {
				if (sorted[i].planOrder >= targetOrder) {
					if (firstConflictIndex === -1) {
						firstConflictIndex = i; // FIRST occurrence
					}

					sorted[i] = {
						...sorted[i],
						planOrder: sorted[i].planOrder + 1
					};
				}
			}

			// Fix gaps / duplicates AFTER first occurrence
			if (firstConflictIndex > 0) {
				for (let i = firstConflictIndex + 1; i < sorted.length; i++) {
					if (sorted[i].planOrder - sorted[i - 1].planOrder !== 1) {
						sorted[i] = {
							...sorted[i],
							planOrder: sorted[i - 1].planOrder + 1
						};
					}
				}
			}

			setPlanOrderList(sorted);
			setShowModal(false);
		},
		[planOrderList]
	);
	//console.log("planOrderList", planOrderList);

	useEffect(() => {
		if (queryGroupNumber && Number(queryGroupNumber) === 300) {
			setPlan(
				Object.assign(
					plan,
					{},
					{
						employer_contribution: {
							EE: employeeCoverage,
							ES: employeeCoverage,
							EC: employeeCoverage,
							ECH: employeeCoverage,
							ED: employeeCoverage
						}
					}
				)
			);
		}
	}, [queryGroupNumber]);
	useEffect(() => {
		if (targetOrder != null) {
			setFormData((prev) => ({ ...prev, plan_order: targetOrder }));
		}
		if (currentPlan) {
			updateAllplanOrder();
		}
	}, [targetOrder, currentPlan]);

	const handleSubmit = async () => {
		try {
			console.log("this is the plan id", planId);
			if (!planId) return alert("Plan ID is missing!");

			const normalizedPayFrequency = (formData.pay_frequency || []).map((pf: string) => pf.toUpperCase());

			const MainexcelPayload = {
				...excelPayload,
				premium_amount: jsonOutput || null
			};

			if (step == steps.length) {
				if (jsonOutput) {
					await trackPromise(api.plan.updateVEBPlan(planId, MainexcelPayload));
					if (Document) {
						const formData = new FormData();

						formData.append(
							"plan",
							JSON.stringify({
								_id: planId,
								group_number: queryGroupNumber as number,
								document: null
							})
						);

						formData.append("document", Document);

						const updatedDocument = await trackPromise(api.plan.updatePlanDocument(formData));
					}

					alert("Plan Created Successfully");
					navigate(`/employer/plan-management?gn=${queryGroupNumber}`);
				}
			}
		} catch (err: any) {
			console.error(err);
			alert(err.response?.data?.message || "Failed to update plan");
		}
	};
	return (
		<div className="pf-page">
			{loading && <LoadingIndicator />}

			<div
				style={{
					maxWidth: "1400px",
					width: "96%",
					margin: "0 auto",
					display: "flex",
					flexDirection: "column",
					gap: 12
				}}
			>
				<Box sx={{ position: "sticky", top: 16, zIndex: 1000 }}>
					<div className="pf-card" style={{ borderRadius: "var(--pf-radius-lg)" }}>
						<div
							className="pf-card-header"
							style={{ padding: "10px 20px 8px", borderBottom: "0.5px solid var(--pf-border)" }}
						>
							<div style={{ display: "flex", alignItems: "baseline", gap: 10 }}>
								<p className="pf-card-title" style={{ fontSize: 16, margin: 0 }}>
									Voluntary Employee Benefits
								</p>
								<p className="pf-card-subtitle" style={{ margin: 0, fontSize: 12 }}>
									Complete all required fields across each step.
								</p>
							</div>
						</div>

						<div className="pf-steps" style={{ padding: "8px 20px" }}>
							{steps.map((label, idx) => (
								<div
									key={label}
									className={`pf-step ${
										idx === step - 1 ? "pf-step--active" : idx < step - 1 ? "pf-step--done" : ""
									}`}
									onClick={() => {
										if (step !== 7 && idx < step - 1) setStep(idx + 1);
									}}
									style={{ cursor: idx < step - 1 ? "pointer" : "default" }}
								>
									{idx + 1} · {label}
								</div>
							))}
						</div>

						<LinearProgress
							variant="determinate"
							value={(step / steps.length) * 100}
							sx={{
								height: 2,
								borderRadius: 0,
								bgcolor: "rgba(0,0,0,0.06)",
								"& .MuiLinearProgress-bar": { backgroundColor: "var(--pf-accent)" }
							}}
						/>
					</div>
				</Box>

				<div className="pf-card" style={{ borderRadius: "var(--pf-radius-lg)" }}>
					<div className="pf-body">
						<div className="pf-field pf-mui-field">
							<div className="pf-label-text required">Group number</div>
							<TextField
								name="group_number"
								value={queryGroupNumber}
								variant="outlined"
								inputProps={{ readOnly: true }}
								sx={{
									width: 200,
									"& .MuiInputBase-input": { padding: "9px 12px" }
								}}
							/>
						</div>

						<hr className="pf-divider" />

						<form>{stepFields(step).map((field) => renderField(field))}</form>
					</div>

					<div className="pf-card-footer">
						<span className="pf-footer-note">* Required fields</span>

						<div className="pf-footer-actions">
							{/* Back */}
							<button
								className="pf-btn"
								onClick={handleBack}
								disabled={step === 1}
								style={{
									opacity: step === 1 ? 0.4 : 1,
									cursor: step === 1 ? "not-allowed" : "pointer"
								}}
							>
								← Back
							</button>

							{/* Next / Final / Submit */}
							{step === 6 ? (
								<FinalStepButton
									step={step}
									handleNext={handleNext}
									handleCreatePlanClick={handleCreatePlanClick}
								/>
							) : step < 6 ? (
								<button className="pf-btn pf-btn--primary" onClick={handleNext}>
									Continue →
								</button>
							) : step === 7 ? (
								<>
									{isFileChanged && (
										<button
											className="pf-btn"
											onClick={async () => {
												if (!currentPlan) {
													alert("Plan not loaded yet");
													return;
												}
												if (!jsonOutput && file) await handleConvert(file);
											}}
											disabled={loading}
										>
											{loading ? (
												<>
													<CircularProgress
														size={14}
														thickness={4}
														sx={{ color: "var(--pf-accent)" }}
													/>
													Processing…
												</>
											) : (
												"Wrong Excel"
											)}
										</button>
									)}
									<button
										className="pf-btn pf-btn--primary"
										onClick={handleSubmit}
										disabled={loading}
									>
										{loading ? "Finishing…" : "Submit & Complete"}
									</button>
								</>
							) : null}
						</div>
					</div>
				</div>
			</div>

			<Modal open={showModal} onClose={handleCancel} aria-labelledby="duplicate-order-modal">
				<Box
					sx={{
						position: "absolute",
						top: "50%",
						left: "50%",
						transform: "translate(-50%, -50%)",
						width: 560,
						maxHeight: "80vh",
						overflowY: "auto",
						bgcolor: "background.paper",
						borderRadius: "var(--pf-radius-lg)",
						boxShadow: "0 8px 32px rgba(0,0,0,0.14)",
						p: 4
					}}
				>
					<Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
						<div
							style={{
								fontFamily: "var(--pf-font-serif)",
								fontSize: 18,
								color: "var(--pf-text)",
								letterSpacing: "-0.2px"
							}}
						>
							Duplicate plan order
						</div>
						<IconButton onClick={handleCancel} size="small">
							<IoCloseCircleOutline size={22} />
						</IconButton>
					</Box>

					<p style={{ fontSize: 13, color: "var(--pf-text-muted)", marginBottom: 16, lineHeight: 1.6 }}>
						The plan order <strong style={{ color: "var(--pf-text)" }}>{formData.plan_order}</strong> is
						already assigned to the following plan(s):
					</p>

					<Box sx={{ mb: 3 }}>
						<Table
							size="small"
							sx={{
								border: "0.5px solid var(--pf-border)",
								borderRadius: "var(--pf-radius)",
								overflow: "hidden"
							}}
						>
							<TableHead>
								<TableRow
									sx={{
										bgcolor: "var(--pf-surface)",
										"& th": {
											fontFamily: "var(--pf-font-ui)",
											fontWeight: 500,
											fontSize: "0.8rem",
											letterSpacing: "0.06em",
											textTransform: "uppercase",
											color: "var(--pf-text-muted)",
											borderBottom: "0.5px solid var(--pf-border)",
											padding: "10px 12px"
										}
									}}
								>
									<TableCell>Plan name</TableCell>
									<TableCell>Plan code</TableCell>
									<TableCell align="center">Order</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{planOrderList.map((plan) => (
									<TableRow
										key={plan.plancode}
										sx={{
											"&:hover": { bgcolor: "var(--pf-surface)" },
											"& td": {
												fontSize: "0.85rem",
												color: "var(--pf-text)",
												borderBottom: "0.5px solid var(--pf-border)",
												padding: "10px 12px"
											}
										}}
									>
										<TableCell>{plan.planName}</TableCell>
										<TableCell style={{ color: "var(--pf-text-muted)" }}>{plan.plancode}</TableCell>
										<TableCell align="center">{plan.planOrder}</TableCell>
									</TableRow>
								))}
							</TableBody>
						</Table>
					</Box>

					<Box display="flex" justifyContent="flex-end" flexWrap="wrap" gap={1.5}>
						<TextField
							type="text"
							label="Position"
							size="small"
							value={targetOrder ?? ""}
							onChange={(e) => setTargetOrder(Number(e.target.value))}
							sx={{
								width: 110,
								"& .MuiInputBase-input": { padding: "9px 12px", fontSize: 14 },
								"& .MuiOutlinedInput-root": { borderRadius: "var(--pf-radius)" }
							}}
						/>
						<button
							className="pf-btn pf-btn--primary"
							onClick={() => targetOrder !== null && handleMoveToPosition(targetOrder)}
						>
							Move to position
						</button>
						<button className="pf-btn" onClick={handleCancel}>
							Cancel
						</button>
					</Box>
				</Box>
			</Modal>
		</div>
	);
};

export default CreateVEBPlanV2;
